/**
 * @module module/explore-simple-sk
 * @description <h2><code>explore-simple-sk</code></h2>
 *
 * Element for exploring data.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LabelMode: function() {
        return LabelMode;
    },
    DEFAULT_RANGE_S: function() {
        return DEFAULT_RANGE_S;
    },
    isValidSelection: function() {
        return isValidSelection;
    },
    selectionToEvent: function() {
        return selectionToEvent;
    },
    defaultPointSelected: function() {
        return defaultPointSelected;
    },
    State: function() {
        return State;
    },
    calculateRangeChange: function() {
        return calculateRangeChange;
    },
    ExploreSimpleSk: function() {
        return ExploreSimpleSk;
    }
});
const _html = require("lit/html.js");
const _when = require("lit/directives/when.js");
const _ref = require("lit/directives/ref.js");
const _define = require("../../../elements-sk/modules/define");
const _nudgeutil = require("./nudge-util");
const _query = require("../../../infra-sk/modules/query");
const _errorMessage = require("../errorMessage");
const _httpstatuscodes = require("http-status-codes");
const _ElementSk = require("../../../infra-sk/modules/ElementSk");
require("@material/web/button/outlined-button.js");
require("@material/web/icon/icon.js");
require("@material/web/iconbutton/outlined-icon-button.js");
require("@material/web/switch/switch.js");
require("@material/web/dialog/dialog.js");
require("../keyboard-shortcuts-help-sk/keyboard-shortcuts-help-sk");
require("../../../elements-sk/modules/checkbox-sk");
require("../../../elements-sk/modules/collapse-sk");
require("../../../elements-sk/modules/icons/expand-less-icon-sk");
require("../../../elements-sk/modules/icons/expand-more-icon-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
require("../../../elements-sk/modules/icons/close-icon-sk");
require("../../../elements-sk/modules/spinner-sk");
require("../../../elements-sk/modules/tabs-panel-sk");
require("../../../elements-sk/modules/tabs-sk");
require("../../../elements-sk/modules/toast-sk");
require("../../../infra-sk/modules/query-sk");
require("../../../infra-sk/modules/paramset-sk");
require("../commit-detail-panel-sk");
require("../commit-range-sk");
require("../domain-picker-sk");
require("../json-source-sk");
require("../picker-field-sk");
require("../pivot-query-sk");
require("../pivot-table-sk");
require("../plot-google-chart-sk");
require("../plot-summary-sk");
require("../point-links-sk");
require("../split-chart-menu-sk");
require("../query-count-sk");
require("../graph-title-sk");
require("../new-bug-dialog-sk");
require("../existing-bug-dialog-sk");
require("../window/window");
const _json = require("../json");
const _pivotutil = require("../pivotutil");
const _paramtools = require("../paramtools");
const _commitrangesk = require("../commit-range-sk/commit-range-sk");
const _const = require("../const/const");
const _aloginsk = require("../../../infra-sk/modules/alogin-sk/alogin-sk");
const _dataframe = require("../dataframe");
const _traceformatter = require("../trace-details-formatter/traceformatter");
require("../chart-tooltip-sk/chart-tooltip-sk");
require("../dataframe/dataframe_context");
const _dom = require("../../../infra-sk/modules/dom");
const _index = require("../dataframe/index");
const _traceset = require("../dataframe/traceset");
const _keyboardshortcuts = require("../common/keyboard-shortcuts");
const _graphconfig = require("../common/graph-config");
const _dataservice = require("../data-service");
const _csv = require("../csv");
const _testpicker = require("../common/test-picker");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const DOMAIN_DATE = 'date';
const DOMAIN_COMMIT = 'commit';
const EXPLORE_SIMPLE_PAGE_SOURCE = 'explore-simple-sk';
// Amount of datapoints that is expected to begin affecting performance.
const DATAPOINT_THRESHOLD = 100000;
const DEFAULT_RANGE_S = 24 * 60 * 60; // 2 days in seconds.
// The index of the params tab.
const PARAMS_TAB_INDEX = 0;
// The percentage of the current zoom window to pan or zoom on a keypress.
const ZOOM_JUMP_PERCENT = (0, _json.CommitNumber)(0.1);
// When we are zooming around and bump into the edges of the graph, how much
// should we widen the range of commits, as a percentage of the currently
// displayed commit.
const RANGE_CHANGE_ON_ZOOM_PERCENT = 0.5;
// The minimum length [right - left] of a zoom range.
const MIN_ZOOM_RANGE = 0.1;
// The max number of points a user can nudge an anomaly by.
const NUDGE_RANGE = 2;
const monthInSec = 30 * 24 * 60 * 60;
// max number of charts to show on a page
const chartsPerPage = 11;
const HOVER_DEBOUNCE_MS = 100;
// Even though pivot.Request sent to the server can be null, we don't want to
// put use a null in state, as that won't let stateReflector figure out the
// right types inside pivot.Request, so we default to an invalid value here.
const defaultPivotRequest = ()=>({
        group_by: [],
        operation: 'avg',
        summary: []
    });
var LabelMode;
(function(LabelMode) {
    LabelMode[LabelMode["Date"] = 0] = "Date";
    LabelMode[LabelMode["CommitPosition"] = 1] = "CommitPosition";
})(LabelMode || (LabelMode = {}));
const isValidSelection = (p)=>p.name !== '';
const selectionToEvent = (p, header)=>{
    let x = -1;
    if (header !== null) {
        // Find the index of the ColumnHeader that matches the commit.
        x = header.findIndex((h)=>{
            if (h === null) {
                return false;
            }
            return h.offset === p.commit;
        });
    }
    return new CustomEvent('', {
        detail: {
            x: x,
            y: 0,
            name: p.name
        }
    });
};
const defaultPointSelected = ()=>({
        commit: (0, _json.CommitNumber)(0),
        name: '',
        tableRow: -1,
        tableCol: -1
    });
let State = class State {
    constructor(){
        this.begin = -1;
        this.end = -1;
        this.formulas = [];
        this.queries = [];
        this.keys = '' // The id of the shortcut to a list of trace keys.
        ;
        this.xbaroffset = -1 // The offset of the commit in the repo.
        ;
        this.showZero = false;
        this.numCommits = 250;
        this.requestType = 1 // 0 to use begin/end, 1 to use numCommits.
        ;
        this.pivotRequest = defaultPivotRequest();
        this.sort = '' // Pivot table sort order.
        ;
        this.selected = defaultPointSelected() // The point on a trace that was clicked on.
        ;
        this.domain = DOMAIN_COMMIT // The domain of the x-axis, either commit or date. Default commit
        ;
        // Deprecated.
        this.labelMode = LabelMode.Date // The label mode for the x-axis, date or commit.
        ;
        this.incremental = false // Enables a data fetching optimization.
        ;
        this.disable_filter_parent_traces = false;
        this.plotSummary = false;
        this.disableMaterial = false;
        this.highlight_anomalies = [];
        this.enable_chart_tooltip = false;
        this.show_remove_all = true;
        this.use_titles = false;
        this.useTestPicker = false;
        this.use_test_picker_query = false;
        // boolean indicate for enabling favorites action. set by explore-sk.
        // requires user to be logged in so that the favorites can be saved for the user.
        this.enable_favorites = false;
        // boolean indicating if param set details shown be shown below a chart
        this.hide_paramset = false;
        // boolean indicating if zoom should be horizontal or vertical
        this.horizontal_zoom = false;
        this.graph_index = 0 // The index of the graph in the list of graphs.
        ;
        // boolean indicating if the element should disable querying of data from backend.
        this.doNotQueryData = false;
        // boolean indicating if the chart should space x-axis points evenly, treating them as categories.
        this.evenXAxisSpacing = false;
    }
};
// TODO(jcgregorio) Move to a 'key' module.
// Returns true if paramName=paramValue appears in the given structured key.
function _matches(key, paramName, paramValue) {
    return key.indexOf(`,${paramName}=${paramValue},`) >= 0;
}
// clamp ensures a number is not negative.
function clampToNonNegative(x) {
    if (x < 0) {
        return 0;
    }
    return x;
}
function calculateRangeChange(zoom, clampedZoom, offsets) {
    // How much we will change the offset if we zoom beyond an edge.
    const offsetDelta = Math.floor((offsets[1] - offsets[0]) * RANGE_CHANGE_ON_ZOOM_PERCENT);
    const exceedsLeftEdge = zoom[0] !== clampedZoom[0];
    const exceedsRightEdge = zoom[1] !== clampedZoom[1];
    if (exceedsLeftEdge && exceedsRightEdge) {
        // shift both
        return {
            rangeChange: true,
            newOffsets: [
                clampToNonNegative(offsets[0] - offsetDelta),
                offsets[1] + offsetDelta
            ]
        };
    }
    if (exceedsLeftEdge) {
        // shift left
        return {
            rangeChange: true,
            newOffsets: [
                clampToNonNegative(offsets[0] - offsetDelta),
                offsets[1] - offsetDelta
            ]
        };
    }
    if (exceedsRightEdge) {
        // shift right
        return {
            rangeChange: true,
            newOffsets: [
                offsets[0] + offsetDelta,
                offsets[1] + offsetDelta
            ]
        };
    }
    return {
        rangeChange: false
    };
}
let ExploreSimpleSk = class ExploreSimpleSk extends _ElementSk.ElementSk {
    get dataLoading() {
        var _this_dfRepo_value;
        var _this_dfRepo_value_loading;
        return (_this_dfRepo_value_loading = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.loading) !== null && _this_dfRepo_value_loading !== void 0 ? _this_dfRepo_value_loading : false;
    }
    set dataLoading(value) {
        if (this.dfRepo.value) {
            this.dfRepo.value.loading = value;
            if (!value) {
                // Dispatch an event to notify that data is loaded for the previous range.
                this.dispatchEvent(new CustomEvent('data-loaded', {
                    bubbles: true
                }));
            }
        }
    }
    get requestComplete() {
        var _this_dfRepo_value;
        var _this_dfRepo_value_requestComplete;
        return (_this_dfRepo_value_requestComplete = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.requestComplete) !== null && _this_dfRepo_value_requestComplete !== void 0 ? _this_dfRepo_value_requestComplete : Promise.resolve(0);
    }
    plotSummaryTemplate() {
        return (0, _html.html)` <plot-summary-sk
      .domain=${this._state.domain}
      ${(0, _ref.ref)(this.plotSummary)}
      @summary_selected=${this.onSummarySelected}
      selectionType=${!this._state.disableMaterial ? 'material' : 'canvas'}
      ?hasControl=${!this._state.disableMaterial}
      class="hide_on_pivot_table hide_on_query_only hide_on_spinner">
    </plot-summary-sk>`;
    }
    get hasTraces() {
        const df = this.getSubDataFrame();
        if (df && df.traceset) {
            const cleanDf = (0, _csv.removeSpecialTraces)(df);
            return Object.keys(cleanDf.traceset).length > 0;
        }
        return false;
    }
    closeExplore() {
        // Remove the explore object from the list in `explore-multi-sk.ts`.
        const detail = {
            elem: this
        };
        this.dispatchEvent(new CustomEvent('remove-explore', {
            detail: detail,
            bubbles: true
        }));
    }
    reset() {
        this.removeAll(false);
        if (this.openQueryByDefault) {
            this.openQuery();
        }
    }
    // Show full graph title if the graph title exists.
    showFullTitle() {
        if (this.graphTitle === null || this.graphTitle === undefined) {
            return;
        }
        this.graphTitle.showFullTitle();
    }
    // Show short graph title if the graph title exists.
    showShortTitle() {
        if (this.graphTitle === null || this.graphTitle === undefined) {
            return;
        }
        this.graphTitle.showShortTitles();
    }
    // Use commit and trace number to find the previous commit in the trace.
    getPreviousCommit(index, traceName) {
        var _this_dfRepo_value, _this_dfRepo_value_header_prevIndex, _this_dfRepo_value1;
        // First the previous commit that has data.
        let prevIndex = index - 1;
        const trace = ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe.traceset[traceName]) || [];
        while(prevIndex > -1 && trace[prevIndex] === _const.MISSING_DATA_SENTINEL){
            prevIndex = prevIndex - 1;
        }
        const previousCommit = ((_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : (_this_dfRepo_value_header_prevIndex = _this_dfRepo_value1.header[prevIndex]) === null || _this_dfRepo_value_header_prevIndex === void 0 ? void 0 : _this_dfRepo_value_header_prevIndex.offset) || null;
        if (previousCommit === null) {
            return null;
        }
        return previousCommit;
    }
    /**
   * getCommitDetails returns the commit details for the given commit position
   * from the dataframe header.
   * @param commitPosition Commit position to query.
   * @returns ColumnHeader object containing the details.
   */ getCommitDetails(commitPosition) {
        var _this_dfRepo_value;
        let colHeader = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header.find((colHeader)=>{
            var _colHeader;
            return ((_colHeader = colHeader) === null || _colHeader === void 0 ? void 0 : _colHeader.offset) === commitPosition;
        });
        if (colHeader === undefined) {
            colHeader = null;
        }
        return colHeader;
    }
    getCommitIndex(value, type = DOMAIN_COMMIT, max = false) {
        var _this_dfRepo_value;
        // Ensure the index value is an integer.
        value = Math.round(value);
        const header = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header;
        if (!header || header.length === 0) {
            return -1;
        }
        const prop = type === DOMAIN_COMMIT ? 'offset' : 'timestamp';
        // First, try to find an exact match.
        let index = header.findIndex((h)=>{
            var _h;
            return ((_h = h) === null || _h === void 0 ? void 0 : _h[prop]) === value;
        });
        if (index !== -1) {
            return index;
        }
        // If no exact match, find the index of the first element greater than value.
        index = header.findIndex((h)=>h !== undefined && h !== null && h[prop] > value);
        // If no element is greater, 'value' is larger than all elements.
        // The closest is the last one.
        if (index === -1 || index === 0 && max) {
            return header.length - 1;
        }
        // If 'value' is smaller than all elements, the closest is the first one.
        if (index === 0) {
            return 0;
        }
        // We have two candidates, the one before and the one at the found index.
        // Compare with the previous element to see which is closer.
        const diffNext = header[index][prop] - value;
        const diffPrev = value - header[index - 1][prop];
        if (diffNext < diffPrev) {
            return index;
        }
        return index - 1;
    }
    // onChartSelect shows the tooltip whenever a user clicks on a data
    // point and the tooltip will lock in place until it is closed.
    onChartSelect(e) {
        var _this_dfRepo_value, _this_selectedRange;
        const chart = this.googleChartPlot.value;
        const index = e.detail;
        const commitPos = chart.getCommitPosition(index.tableRow);
        const traceName = chart.getTraceName(index.tableCol);
        const anomaly = ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.getAnomaly(traceName, commitPos)) || null;
        this.selectedAnomaly = anomaly;
        const position = chart.getPositionByIndex(index);
        const commit = this.getCommitDetails(commitPos);
        const prevCommit = this.getCommitDetails(this.getPreviousCommit(index.tableRow, traceName));
        this.state.selected = {
            name: traceName,
            commit: commitPos,
            tableCol: index.tableCol,
            tableRow: index.tableRow
        };
        this.enableTooltip({
            x: index.tableRow - (((_this_selectedRange = this.selectedRange) === null || _this_selectedRange === void 0 ? void 0 : _this_selectedRange.begin) || 0),
            y: chart.getYValue(index),
            xPos: position.x,
            yPos: position.y,
            name: traceName
        }, [
            prevCommit,
            commit
        ], true);
        this.tooltipSelected = true;
        this._stateHasChanged();
        // If traces are rendered and summary bar is enabled, show
        // summary for the trace clicked on the graph.
        if (this.summaryOptionsField.value && this.traceIdSummaryOptionMap.size > 1) {
            const option = this.traceIdSummaryOptionMap.get(traceName) || '';
            if (option !== '') {
                this.summaryOptionsField.value.selectedItems = [
                    option
                ];
            } else {
                (0, _errorMessage.errorMessage)(`Summary bar not properly set for this trace. Trace Name: ${traceName}`, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                });
            }
        }
    }
    // if the tooltip is opened and the user is not shift-clicking,
    // close it when clicking on the chart
    // i.e. clicking away from the tooltip closes it
    // One edge case this implementation does not address is if the user
    // tries to click onto another data point while the tooltip is open.
    // This action is treated as onChartMouseDown and not as
    // onChartSelect so the tooltip only closes.
    onChartMouseDown() {
        window.clearTimeout(this.hoverTimeout);
        this.closeTooltip();
    }
    // Close the tooltip when moving away while hovering.
    // Tooltip stays if the data point has been selected (clicked-on)
    onChartMouseOut() {
        window.clearTimeout(this.hoverTimeout);
        if (!this.tooltipSelected) {
            this.closeTooltip();
        }
    }
    // onChartOver shows the tooltip whenever a user hovers their mouse
    // over a data point in the google chart
    onChartOver({ detail }) {
        window.clearTimeout(this.hoverTimeout);
        const chart = this.googleChartPlot.value;
        if (this.paramset) {
            this.paramset.highlight = (0, _paramtools.fromKey)(chart.getTraceName(detail.tableCol));
        }
        if (this.tooltipSelected) {
            return;
        }
        this.hoverTimeout = window.setTimeout(()=>{
            var _this_selectedRange;
            const commitPos = chart.getCommitPosition(detail.tableRow);
            const position = chart.getPositionByIndex(detail);
            const traceName = chart.getTraceName(detail.tableCol);
            const currentCommit = this.getCommitDetails(commitPos);
            const prevCommit = this.getCommitDetails(this.getPreviousCommit(detail.tableRow, traceName));
            this.enableTooltip({
                x: detail.tableRow - (((_this_selectedRange = this.selectedRange) === null || _this_selectedRange === void 0 ? void 0 : _this_selectedRange.begin) || 0),
                y: chart.getYValue(detail),
                xPos: position.x,
                yPos: position.y,
                name: chart.getTraceName(detail.tableCol)
            }, [
                prevCommit,
                currentCommit
            ], false);
        }, HOVER_DEBOUNCE_MS);
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('anomalies-source-changed', this._onAnomaliesSourceChanged);
        if (this._initialized) {
            return;
        }
        this.setUseDiscreteAxis(this._state.evenXAxisSpacing);
        this._initialized = true;
        this.render();
        this.detailTab = this.querySelector('#detailTab');
        this.formula = this.querySelector(`#formula-${this.uniqueId}`);
        this.json = this.querySelector(`#json-${this.uniqueId}`);
        if (this.json && this.json.value === '') {
            this.json.value = JSON.stringify({
                graphs: [
                    {
                        queries: [],
                        formulas: [],
                        keys: ''
                    }
                ]
            }, null, 2);
        }
        this.logEntry = this.querySelector('#logEntry');
        this.paramset = this.querySelector('#paramset');
        this.percent = this.querySelector('#percent');
        this.pivotControl = this.querySelector('pivot-query-sk');
        this.pivotDisplayButton = this.querySelector(`#pivot-display-button-${this.uniqueId}`);
        this.pivotTable = this.querySelector('pivot-table-sk');
        this.query = this.querySelector('#query');
        this.queryCount = this.querySelector('query-count-sk');
        this.range = this.querySelector('#range');
        this.spinner = this.querySelector('#spinner');
        this.summary = this.querySelector('#summary');
        this.commitTime = this.querySelector('#commit_time');
        this.queryDialog = this.querySelector('#query-dialog');
        this.helpDialog = this.querySelector('#help');
        this.pinpointJobToast = this.querySelector('#pinpoint-job-toast');
        this.closePinpointToastButton = this.querySelector('#hide-pinpoint-toast');
        this.triageResultToast = this.querySelector('#triage-result-toast');
        this.closeTriageToastButton = this.querySelector('#hide-triage-toast');
        this.collapseButton = this.querySelector('#collapseButton');
        this.graphTitle = this.querySelector('#graphTitle');
        this.is_anomaly_table = document.querySelector('#anomaly-table') ? true : false;
        // Update the range picker's state from our own state, since our state may
        // have been set before we were attached to the DOM and this.range was populated.
        if (this.range) {
            this.range.state = {
                begin: this._state.begin,
                end: this._state.end,
                num_commits: this._state.numCommits,
                request_type: this._state.requestType
            };
        }
        // material UI stuff
        this.settingsDialog = this.querySelector('#settings-dialog');
        // Populate the query element.
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (this.user === '') {
            (0, _aloginsk.LoggedIn)().then((status)=>{
                this.user = status.email;
            }).catch((msg)=>(0, _errorMessage.errorMessage)(msg, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.UNAUTHORIZED.toString()
                }));
        }
        if (this.state.graph_index === 0) {
            this.dataService.getInitPage(tz).then((json)=>{
                this.range.state = {
                    begin: this._state.begin,
                    end: this._state.end,
                    num_commits: this._state.numCommits,
                    request_type: this._state.requestType
                };
                this.query.key_order = window.perf.key_order || [];
                this.query.paramset = json.dataframe.paramset;
                this.pivotControl.paramset = json.dataframe.paramset;
                // Remove the paramset so it doesn't get displayed in the Params tab.
                json.dataframe.paramset = {};
            }).catch((msg)=>{
                if (msg instanceof _dataservice.DataServiceError) {
                    var _msg_status;
                    (0, _errorMessage.errorMessage)(msg.message, 0, {
                        source: EXPLORE_SIMPLE_PAGE_SOURCE,
                        errorCode: ((_msg_status = msg.status) === null || _msg_status === void 0 ? void 0 : _msg_status.toString()) || '500',
                        endpoint: msg.endpoint,
                        method: msg.method,
                        stack: msg.stack
                    });
                } else {
                    (0, _errorMessage.errorMessage)(msg, 0, {
                        source: EXPLORE_SIMPLE_PAGE_SOURCE,
                        errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                    });
                }
            });
        }
        this.closePinpointToastButton.addEventListener('click', ()=>{
            var _this_pinpointJobToast;
            return (_this_pinpointJobToast = this.pinpointJobToast) === null || _this_pinpointJobToast === void 0 ? void 0 : _this_pinpointJobToast.hide();
        });
        this.closeTriageToastButton.addEventListener('click', ()=>{
            var _this_triageResultToast;
            return (_this_triageResultToast = this.triageResultToast) === null || _this_triageResultToast === void 0 ? void 0 : _this_triageResultToast.hide();
        });
        // Add an event listener for when a new bug is filed or an existing bug is submitted in the tooltip.
        this.addEventListener('anomaly-changed', (e)=>{
            const detail = e.detail;
            if (!detail) {
                var _this_triageResultToast;
                (_this_triageResultToast = this.triageResultToast) === null || _this_triageResultToast === void 0 ? void 0 : _this_triageResultToast.hide();
                return;
            }
            const toastText = document.getElementById('triage-result-text');
            // Display error passed in from event, do not attempt to change anomalies.
            if (detail.error) {
                var _this_triageResultToast1;
                toastText.textContent = `${detail.error}`;
                (_this_triageResultToast1 = this.triageResultToast) === null || _this_triageResultToast1 === void 0 ? void 0 : _this_triageResultToast1.show();
                return;
            }
            const anomalies = detail.anomalies;
            const traceNames = detail.traceNames;
            if (anomalies.length === 0 || traceNames.length === 0) {
                var _this_triageResultToast2;
                (_this_triageResultToast2 = this.triageResultToast) === null || _this_triageResultToast2 === void 0 ? void 0 : _this_triageResultToast2.hide();
                return;
            }
            for(let i = 0; i < anomalies.length; i++){
                var _this_triageResultToast3;
                const commits = [];
                const anomalyMap = {};
                const commitMap = {};
                // TraceName should be the same across all anomalies.
                const traceName = traceNames[i] || traceNames[0];
                const startRevision = anomalies[i].start_revision;
                // Load all commits available on the plot.
                const data = this.dfRepo.value.dataframe.header;
                if (data) {
                    // Create array of all commits for easy lookup.
                    data.forEach((data)=>commits.push(data.offset));
                }
                // Find the commit corresponding to the anomaly's display commit.
                let anomalyCommit = 0;
                const displayCommit = anomalies[i].display_commit_number;
                anomalyCommit = commits.find((commit)=>displayCommit && commit === displayCommit);
                if (anomalyCommit) {
                    var _this_dfRepo_value;
                    commitMap[anomalyCommit] = anomalies[i];
                    anomalyMap[traceName] = commitMap;
                    (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.updateAnomalies(anomalyMap, anomalies[i].id);
                }
                // Update pop-up with bug details from anomaly change.
                const bugId = detail.bugId;
                const displayIndex = detail.displayIndex;
                const editAction = detail.editAction;
                const toastLink = document.getElementById('triage-result-link');
                toastLink.innerText = ``;
                // BugId dictates that a bug is tied to the anomaly. (New or Existing).
                if (bugId) {
                    toastText.textContent = `Anomaly associated with: `;
                    const link = `https://issues.chromium.org/issues/${bugId}`;
                    toastLink.innerText = `${bugId}`;
                    toastLink.setAttribute('href', `${link}`);
                    toastLink.setAttribute('target', '_blank');
                }
                // EditAction dictates this is a state change.
                if (editAction) {
                    toastText.textContent = `Anomaly state changed to ${editAction}`;
                }
                // DisplayIndex dictates this is a nudge change.
                if (displayIndex) {
                    if (anomalyCommit) {
                        toastText.textContent = `Anomaly Nudge Moved (${displayIndex}) to ${anomalyCommit}`;
                        // Since anomaly is moving, close tooltip.
                        this.closeTooltip();
                    } else {
                        // If no anomaly commit was found, then the nudge failed.
                        toastText.textContent = `Anomaly Nudge Failed (${displayIndex}) to ${startRevision}!`;
                    }
                }
                (_this_triageResultToast3 = this.triageResultToast) === null || _this_triageResultToast3 === void 0 ? void 0 : _this_triageResultToast3.show();
                this._stateHasChanged();
                this.render();
            }
        });
        // Listens to the user-issue-changed event and does appropriate actions
        // to update the overall userIssue map along with re-rendering the
        // new set of user issues on the chart
        this.addEventListener('user-issue-changed', (e)=>{
            const repo = this.dfRepo.value;
            const traceKey = e.detail.trace_key;
            const commitPosition = e.detail.commit_position;
            const bugId = e.detail.bug_id;
            // Update the over user issues map in dataframe_context
            repo.updateUserIssue(traceKey, commitPosition, bugId);
        });
        this.addEventListener('plot-chart-mousedown', ()=>{
            this.onChartMouseDown();
        });
        this.addEventListener('plot-chart-mouseout', ()=>{
            this.onChartMouseOut();
        });
        this.addEventListener('split-chart-selection', (e)=>{
            this.splitByAttribute(e);
        });
    }
    render() {
        this._render();
        // Determine if in split chart mode.
        const chartTotal = document.querySelectorAll('explore-simple-sk');
        const testPicker = document.querySelector('test-picker-sk');
        this.is_chart_split = chartTotal.length > 1 && testPicker ? true : false;
    }
    showSettingsDialog(_event) {
        this.settingsDialog.show();
    }
    // Handle the x-axis switch toggle.
    // If the switch is selected, set the x-axis to date mode.
    switchXAxis(target) {
        if (!target) return;
        const newDomain = target.selected ? DOMAIN_DATE : DOMAIN_COMMIT;
        // Dispatch the event first to sync other charts.
        if (this.is_chart_split) {
            const detail = {
                index: this.state.graph_index,
                domain: newDomain
            };
            this.dispatchEvent(new CustomEvent('x-axis-toggled', {
                detail,
                bubbles: true
            }));
        }
        // Then update the current chart.
        this.updateXAxis(newDomain);
    }
    // Set the x-axis domain to either commit or date.
    // This is used to update the x-axis domain when the user toggles the switch.
    // It also is an entry point from multichart to update related charts which is
    // why it has a separate method.
    updateXAxis(domain) {
        if (this.state.domain === domain) {
            return;
        }
        this._updateSelectionRangeForDomainChange(domain);
        // Now, update the state and the child components' domains.
        this.xAxisSwitch = !this.xAxisSwitch;
        this._state.domain = domain;
        this._state.labelMode = domain === DOMAIN_DATE ? LabelMode.Date : LabelMode.CommitPosition;
        if (this.googleChartPlot.value) {
            this.googleChartPlot.value.domain = domain;
        }
        if (this.plotSummary.value) {
            this.plotSummary.value.domain = domain;
        }
        this.render();
        this._stateHasChanged();
    }
    _updateSelectionRangeForDomainChange(newDomain) {
        var _this_dfRepo_value;
        const header = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header;
        const plotSummary = this.plotSummary.value;
        const oldDomain = this.state.domain;
        if (header && plotSummary && plotSummary.selectedValueRange) {
            const currentRange = plotSummary.selectedValueRange;
            const beginIndex = this.getCommitIndex(currentRange.begin, oldDomain);
            const endIndex = this.getCommitIndex(currentRange.end, oldDomain, true);
            if (beginIndex !== -1 && endIndex !== -1) {
                const newBegin = newDomain === DOMAIN_DATE ? header[beginIndex].timestamp : header[beginIndex].offset;
                const newEnd = newDomain === DOMAIN_DATE ? header[endIndex].timestamp : header[endIndex].offset;
                const newRange = {
                    begin: newBegin,
                    end: newEnd
                };
                // Set the cached value on the child. It will apply this selection once
                // its internal chart has re-rendered with the new domain.
                plotSummary.cachedSelectedValueRange = newRange;
            }
        }
    }
    // updates the chart height using a string input.
    // typically 500px for a single chart and 250px for multiple charts
    updateChartHeight(height) {
        const chart = this.querySelector('div.chart-container');
        chart.classList.remove('small-height', 'medium-height');
        chart.style.height = '';
        if (height === '250px') {
            chart.classList.add('small-height');
        } else if (height === '500px') {
            chart.classList.add('medium-height');
        } else {
            chart.style.height = height;
        }
    }
    /**
   * Asynchronously updates the URL for the Multigraph (/m/?shortcut=...) link.
   *
   * This method constructs a URL based on the current graph configuration
   * (queries, formulas, keys) and time range (`begin`, `end`, `requestType`)
   * stored in `this._state`.
   *
   * It calls the `updateShortcut` function to asynchronously obtain a shortcut ID
   * for the current graph state. Once the shortcut ID is retrieved, it builds
   * a new URL for the multi-graph page (`/m/`) including the state parameters
   * and the shortcut.
   *
   * Uninitialized link placeholder is "#".
   */ updateTestPickerUrl() {
        const currentState = this._state;
        const graphConfig = {
            queries: currentState.queries,
            formulas: currentState.formulas,
            keys: currentState.keys
        };
        if (graphConfig.queries.length === 0 && graphConfig.formulas.length === 0 && graphConfig.keys === '') {
            if (this.testPickerUrl !== '#') {
                this.testPickerUrl = '#';
                this._render();
            }
            return;
        }
        (0, _graphconfig.updateShortcut)([
            graphConfig
        ]).then((shortcut)=>{
            let newUrl = shortcut ? `/m/?begin=${currentState.begin}` + `&end=${currentState.end}` + `&request_type=${currentState.requestType}` + `&shortcut=${shortcut}` : '#';
            if (newUrl !== '#' && window.perf && window.perf.default_to_manual_plot_mode) {
                newUrl += '&manual_plot_mode=true';
            }
            if (this.testPickerUrl !== newUrl) {
                this.testPickerUrl = newUrl;
                this._render();
            }
        }).catch((error)=>{
            if (error instanceof _dataservice.DataServiceError && error.status === 500) {
                (0, _errorMessage.errorMessage)('Unable to update shortcut.', 2000, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                });
            }
            console.error('Failed to update shortcut for Test Picker URL:', error);
            if (this.testPickerUrl !== '#') {
                this.testPickerUrl = '#';
                this._render();
            }
        });
    }
    switchZoom(target) {
        this.zoomDirectionSwitch = !this.zoomDirectionSwitch;
        if (target.selected) {
            this.state.horizontal_zoom = true;
        } else {
            this.state.horizontal_zoom = false;
        }
        this.render();
        const detail = {
            key: this.state.horizontal_zoom
        };
        this.dispatchEvent(new CustomEvent('switch-zoom', {
            detail: detail,
            bubbles: true
        }));
    }
    switchEvenXAxisSpacing(target) {
        if (!target) return;
        this._state.evenXAxisSpacing = target.selected;
        this.setUseDiscreteAxis(this._state.evenXAxisSpacing);
        this.render();
        this.dispatchEvent(new CustomEvent('even-x-axis-spacing-changed', {
            detail: {
                value: this._state.evenXAxisSpacing,
                graph_index: this._state.graph_index
            },
            bubbles: true
        }));
        this._stateHasChanged();
    }
    setUseDiscreteAxis(value) {
        this._state.evenXAxisSpacing = value;
        if (this.googleChartPlot.value) {
            this.googleChartPlot.value.useDiscreteAxis = value;
        }
    }
    closeQueryDialog() {
        this.queryDialog.close();
        this._dialogOn = false;
    }
    onZoomIn() {
        this.applyZoomOrPan(1, 0);
    }
    onZoomOut() {
        this.applyZoomOrPan(-1, 0);
    }
    onPanLeft() {
        this.applyZoomOrPan(0, -1);
    }
    onPanRight() {
        this.applyZoomOrPan(0, 1);
    }
    onTriagePositive() {
        const tooltip = (0, _dom.$$)('chart-tooltip-sk', this);
        if (tooltip && tooltip.anomaly && tooltip.anomaly.bug_id === 0) {
            tooltip.openNewBug();
        }
    }
    onTriageNegative() {
        const tooltip = (0, _dom.$$)('chart-tooltip-sk', this);
        if (tooltip && tooltip.anomaly && tooltip.anomaly.bug_id === 0) {
            tooltip.ignoreAnomaly();
        }
    }
    onTriageExisting() {
        const tooltip = (0, _dom.$$)('chart-tooltip-sk', this);
        if (tooltip && tooltip.anomaly && tooltip.anomaly.bug_id === 0) {
            tooltip.openExistingBug();
        }
    }
    onOpenHelp() {
        const help = this.querySelector('keyboard-shortcuts-help-sk');
        help.open();
    }
    /**
   * The current zoom and the length between the left and right edges of
   * the zoom as an object of the form:
   *
   *   {
   *     zoom: [2.0, 12.0],
   *     delta: 10.0,
   *   }
   */ getCurrentZoom() {
        var _header;
        const header = this._dataframe.header;
        // Default to the full range
        const zoom = [
            0,
            (((_header = header) === null || _header === void 0 ? void 0 : _header.length) || 1) - 1
        ];
        const plot = this.googleChartPlot.value;
        if (header && header.length > 0 && plot && plot.selectedRange) {
            // If we have a selected range, we need to map the begin/end values back to
            // indices in the dataframe header.
            const isDate = this._state.domain === DOMAIN_DATE;
            const { begin, end } = plot.selectedRange;
            // Find the index that corresponds to the begin value.
            // We assume the header is sorted.
            const beginIndex = header.findIndex((h)=>{
                if (!h) return false;
                const val = isDate ? h.timestamp : h.offset;
                return val >= begin;
            });
            // Find the index that corresponds to the end value.
            let endIndex = header.findIndex((h)=>{
                if (!h) return false;
                const val = isDate ? h.timestamp : h.offset;
                return val > end;
            });
            // If endIndex is -1, it means the end value is beyond the last element,
            // so we select up to the last element.
            if (endIndex === -1) {
                endIndex = header.length;
            }
            // The endIndex from findIndex is the *first* element > endVal, so the
            // actual range inclusive end index is endIndex - 1.
            endIndex = endIndex - 1;
            if (beginIndex !== -1 && endIndex !== -1 && beginIndex <= endIndex) {
                zoom[0] = beginIndex;
                zoom[1] = endIndex;
            }
        }
        let delta = zoom[1] - zoom[0];
        if (delta < MIN_ZOOM_RANGE) {
            const mid = (zoom[0] + zoom[1]) / 2;
            zoom[0] = mid - MIN_ZOOM_RANGE / 2;
            zoom[1] = mid + MIN_ZOOM_RANGE / 2;
            delta = MIN_ZOOM_RANGE;
        }
        return {
            zoom: zoom,
            delta: delta
        };
    }
    /**
   * Clamp a single zoom endpoint.
   */ clampZoomIndexToDataFrame(z) {
        if (z < 0) {
            z = (0, _json.CommitNumber)(0);
        }
        if (z > this._dataframe.header.length - 1) {
            z = this._dataframe.header.length - 1;
        }
        return z;
    }
    /**
   * Fixes up the zoom range so it always make sense.
   *
   * @param {Array<Number>} zoom - The zoom range.
   * @returns {Array<Number>} The zoom range.
   */ rationalizeZoom(zoom) {
        if (zoom[0] > zoom[1]) {
            const left = zoom[0];
            zoom[0] = zoom[1];
            zoom[1] = left;
        }
        return zoom;
    }
    /**
   * Zooms to the desired range, or changes the range of commits being displayed
   * if the zoom range extends past either end of the current commits.
   *
   * @param zoom is the desired zoom range. Each number is an index into the
   * dataframe.
   */ zoomOrRangeChange(zoom) {
        zoom = this.rationalizeZoom(zoom);
        const clampedZoom = [
            this.clampZoomIndexToDataFrame(zoom[0]),
            this.clampZoomIndexToDataFrame(zoom[1])
        ];
        const offsets = [
            this._dataframe.header[0].offset,
            this._dataframe.header[this._dataframe.header.length - 1].offset
        ];
        const result = calculateRangeChange(zoom, clampedZoom, offsets);
        if (result.rangeChange) {
            // Convert the offsets into timestamps, which are needed when building
            // dataframes.
            const req = {
                begin: result.newOffsets[0],
                end: result.newOffsets[1]
            };
            this.dataService.shift(req).then((json)=>{
                this._state.begin = json.begin;
                this._state.end = json.end;
                this._state.requestType = 0;
                this._stateHasChanged();
                this.rangeChangeImpl();
            }).catch((msg)=>{
                if (msg instanceof _dataservice.DataServiceError) {
                    (0, _errorMessage.errorMessage)(msg.message, 0, {
                        source: EXPLORE_SIMPLE_PAGE_SOURCE,
                        errorCode: msg.status.toString()
                    });
                } else {
                    (0, _errorMessage.errorMessage)(msg, 0, {
                        source: EXPLORE_SIMPLE_PAGE_SOURCE,
                        errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                    });
                }
            });
        } else {
            const header = this._dataframe.header;
            const plot = this.googleChartPlot.value;
            if (!header || !plot) {
                return;
            }
            const isDate = this._state.domain === DOMAIN_DATE;
            const getValue = (idx)=>{
                const h = header[idx];
                return isDate ? h.timestamp : h.offset;
            };
            // If the zoom is within the current dataframe, we don't need to fetch
            // new data, but we do need to update the chart.
            plot.selectedValueRange = {
                begin: getValue(zoom[0]),
                end: getValue(zoom[1])
            };
        }
    }
    pivotChanged(e) {
        // Only enable the Display button if we have a valid pivot.Request and a
        // query.
        this.pivotDisplayButton.disabled = (0, _pivotutil.validatePivotRequest)(e.detail) !== '' || this.query.current_query.trim() === '';
        if (!e.detail || e.detail.summary.length === 0) {
            this.pivotDisplayButton.textContent = 'Display';
        } else {
            this.pivotDisplayButton.textContent = 'Display Table';
        }
    }
    /**
   * Applies zoom or pan operations to the current chart selection.
   *
   * This method calculates the new selection range based on the current selection
   * and the desired zoom/pan direction. It handles two scenarios:
   * 1. The new range is within the currently loaded data bounds:
   *    - Directly updates the visual selection (via plotSummary or googleChartPlot)
   *    - Triggers a 'summary_selected' event to update the main chart view.
   * 2. The new range extends beyond the loaded data:
   *    - Calls `zoomOrRangeChange` to initiate a data fetch for the new range.
   *
   * The logric uses the exact values (Commit Offsets or Timestamps) rather than indices
   * to ensue consistency across different chart components.
   *
   * @param zoomDir 1 for Zoom In (shrink range), -1 for Zoom Out (expand range).
   * @param panDir -1 for Pan Left (shift range left), 1 for Pan Right (shift range right), 0 for none.
   */ applyZoomOrPan(zoomDir, panDir) {
        // We update the selection on the plot summary, which will trigger an event
        // to update the main plot.
        const plotSummary = this.plotSummary.value;
        const dfRepo = this.dfRepo.value;
        if (!plotSummary || !dfRepo) {
            return;
        }
        const currentRange = plotSummary.selectedValueRange;
        if (!currentRange) {
            return;
        }
        const width = currentRange.end - currentRange.begin;
        // We rely on the decimal precision here to ensure smooth zooming.
        // If we rounded to integers, consecutive small zooms might cancel out or stuck
        // (e.g. 10 * 0.1 = 1, but if width is 5, 5 * 0.1 = 0.5 -> rounds to 0 or 1).
        // The visualization (Google Chart) handles floating point ranges correctly.
        const zoomDelta = width * ZOOM_JUMP_PERCENT;
        let newBegin = currentRange.begin;
        let newEnd = currentRange.end;
        if (panDir !== 0) {
            newBegin += panDir * zoomDelta;
            newEnd += panDir * zoomDelta;
        } else {
            newBegin += zoomDir * zoomDelta;
            newEnd -= zoomDir * zoomDelta;
        }
        // Clamp to the loaded data range.
        const header = dfRepo.dataframe.header;
        if (!header || header.length === 0) {
            return;
        }
        const isDate = this._state.domain === DOMAIN_DATE;
        const dataBegin = isDate ? header[0].timestamp : header[0].offset;
        const dataEnd = isDate ? header[header.length - 1].timestamp : header[header.length - 1].offset;
        // Check if we need to fetch more data.
        // If we are panning/zooming out beyond the loaded data, we need to fetch.
        if (newBegin < dataBegin || newEnd > dataEnd) {
            const cz = this.getCurrentZoom();
            const zoom = [
                cz.zoom[0] + (panDir !== 0 ? panDir : zoomDir) * ZOOM_JUMP_PERCENT * cz.delta,
                cz.zoom[1] + (panDir !== 0 ? panDir : -zoomDir) * ZOOM_JUMP_PERCENT * cz.delta
            ];
            this.zoomOrRangeChange(zoom);
            return;
        }
        // Apply visual update
        plotSummary.selectedValueRange = {
            begin: newBegin,
            end: newEnd
        };
        this.summarySelected({
            value: {
                begin: newBegin,
                end: newEnd
            },
            domain: this._state.domain,
            start: 0,
            end: 0
        });
    }
    /**  Returns true if we have any traces to be displayed. */ hasData() {
        // We have data if at least one traceID isn't a special name.
        return Object.keys(this._dataframe.traceset).some((traceID)=>!traceID.startsWith('special_'));
    }
    /** Open the query dialog box. */ openQuery() {
        this.render();
        this._dialogOn = true;
        this.queryDialog.show();
        // If there is a query already plotted, update the counts on the query dialog.
        if (this._state.queries.length > 0) {
            this.queryCount.current_query = this.applyDefaultsToQuery(this.query.current_query);
        }
    }
    paramsetChanged(e) {
        this.query.paramset = e.detail;
        this.pivotControl.paramset = e.detail;
        this.render();
    }
    queryChangeDelayedHandler(e) {
        this.queryCount.current_query = this.applyDefaultsToQuery(e.detail.q);
    }
    /** Reflect the current query to the query summary. */ queryChangeHandler(e) {
        const query = e.detail.q;
        this.summary.paramsets = [
            (0, _query.toParamSet)(query)
        ];
        const formula = this.formula.value;
        if (formula === '') {
            this.formula.value = `filter("${query}")`;
        } else if ((formula.match(/"/g) || []).length === 2) {
            // Only update the filter query if there's one string in the formula.
            this.formula.value = formula.replace(/".*"/, `"${query}"`);
        }
        this.queryCount.current_query = this.applyDefaultsToQuery(e.detail.q);
    }
    pivotTableSortChange(e) {
        this._state.sort = e.detail;
        this._stateHasChanged();
    }
    /** get story name for pinpoint. */ getLastSubtest(d) {
        const tmp = d.subtest_7 || d.subtest_6 || d.subtest_5 || d.subtest_4 || d.subtest_3 || d.subtest_2 || d.subtest_1;
        return tmp ? tmp : '';
    }
    /**
   * React to the summary_selected event.
   * @param e Event object.
   */ onSummarySelected(e) {
        this.summarySelected(e.detail);
    }
    summarySelected(detail) {
        this.updateSelectedRangeWithUpdatedDataframe(detail.value, detail.domain);
        // When summary selection is changed, fetch the comments for the new range
        // and update the plot.
        const dfRepo = this.dfRepo.value;
        var _Math_floor;
        const begin = (_Math_floor = Math.floor(detail.value.begin)) !== null && _Math_floor !== void 0 ? _Math_floor : 0;
        var _Math_ceil;
        const end = (_Math_ceil = Math.ceil(detail.value.end)) !== null && _Math_ceil !== void 0 ? _Math_ceil : 0;
        const invalidRange = begin === 0 || end === 0;
        if (dfRepo !== null && dfRepo !== undefined && !invalidRange) {
            dfRepo.getUserIssues(Object.keys(dfRepo.traces), begin, end).then((userIssues)=>{
                if (Object.keys(userIssues || {}).length > 0) {
                    this.updateSelectedRangeWithUpdatedDataframe(detail.value, detail.domain);
                }
            });
        }
        detail.start = this.getCommitIndex(begin, this.state.domain);
        detail.end = this.getCommitIndex(end, this.state.domain, true);
        // If in multi-graph view, sync all graphs.
        // This event listener will not work on the alerts page
        detail.graphNumber = this.state.graph_index;
        this.dispatchEvent(new CustomEvent('selection-range-changed', {
            bubbles: true,
            detail: detail
        }));
        // Only close tooltip if the point is no longer on the chart.
        if (detail.start === 0) {
            this.closeTooltip();
        }
    }
    async extendRange(range, offset) {
        var _dfRepo_dataframe, _dfRepo;
        const dfRepo = this.dfRepo.value;
        const header = (_dfRepo = dfRepo) === null || _dfRepo === void 0 ? void 0 : (_dfRepo_dataframe = _dfRepo.dataframe) === null || _dfRepo_dataframe === void 0 ? void 0 : _dfRepo_dataframe.header;
        if (!dfRepo || !header || header.length === 0) {
            return;
        }
        if (offset) {
            await dfRepo.extendRange(offset, false);
            return;
        }
        let extendDirection = 0;
        if (range.begin < header[0].offset) {
            extendDirection = -1;
        } else if (range.end > header[header.length - 1].offset) {
            extendDirection = 1;
        }
        if (extendDirection !== 0 || offset !== undefined) {
            await dfRepo.extendRange(extendDirection * monthInSec, false);
        }
    }
    async OnSelectionRange({ type, detail }) {
        const begin = Math.round(detail.value.begin);
        const end = Math.round(detail.value.end);
        const selectionDetail = _object_spread_props(_object_spread({}, detail), {
            value: {
                begin: begin,
                end: end
            },
            start: this.getCommitIndex(begin, this.state.domain),
            end: this.getCommitIndex(end, this.state.domain, true)
        });
        if (type === 'selection-changed') {
            await this.extendRange(selectionDetail.value);
        }
        if (this.plotSummary.value) {
            this.plotSummary.value.selectedValueRange = selectionDetail.value;
        }
        this._stateHasChanged();
        this.closeTooltip();
        // If in multi-graph view, sync all graphs.
        // This event listener will not work on the alerts page
        selectionDetail.graphNumber = this.state.graph_index;
        this.dispatchEvent(new CustomEvent('selection-range-changed', {
            bubbles: true,
            detail: selectionDetail
        }));
        this.updateSelectedRangeWithUpdatedDataframe(selectionDetail.value, selectionDetail.domain);
    }
    // updateSelectedRangeWithPlotSummary is used to synchronize
    // multiple explore-simple-sks on a explore-multi page
    // This function syncs google chart panning and plot-summary selection + panning
    updateSelectedRangeWithPlotSummary(range, beginIndex, endIndex) {
        // Summary bar has not been loaded yet.
        if (!this.plotSummary.value) {
            return;
        }
        if (this.googleChartPlot.value) {
            var _this_dfRepo_value_header_beginIndex, _this_dfRepo_value, _this_dfRepo_value_header_endIndex, _this_dfRepo_value1;
            this.googleChartPlot.value.selectedValueRange = range;
            const begin = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : (_this_dfRepo_value_header_beginIndex = _this_dfRepo_value.header[beginIndex]) === null || _this_dfRepo_value_header_beginIndex === void 0 ? void 0 : _this_dfRepo_value_header_beginIndex.timestamp;
            const end = (_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : (_this_dfRepo_value_header_endIndex = _this_dfRepo_value1.header[endIndex]) === null || _this_dfRepo_value_header_endIndex === void 0 ? void 0 : _this_dfRepo_value_header_endIndex.timestamp;
            this.state.begin = parseInt((begin !== null && begin !== void 0 ? begin : this.state.begin).toString());
            this.state.end = parseInt((end !== null && end !== void 0 ? end : this.state.end).toString());
        }
        this.plotSummary.value.selectedValueRange = range;
        this.closeTooltip();
    }
    updateSelectedRangeWithUpdatedDataframe(range, domain, replot = true) {
        var _this_dfRepo_value, _df, _subDataframe_header;
        // Do not try to initialize graph if no time range yet provided.
        if (range.begin <= 0) {
            return;
        }
        if (this.googleChartPlot.value) {
            this.googleChartPlot.value.selectedRange = range;
            this.googleChartPlot.value.showZero = this.state.showZero;
        }
        const df = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe;
        const header = ((_df = df) === null || _df === void 0 ? void 0 : _df.header) || [];
        const selected = (0, _dataframe.findSubDataframe)(header, range, domain);
        this.selectedRange = selected;
        const subDataframe = (0, _index.generateSubDataframe)(df, selected);
        if (!subDataframe || ((_subDataframe_header = subDataframe.header) === null || _subDataframe_header === void 0 ? void 0 : _subDataframe_header.length) === 0) {
            // If the subDataframe is empty, we cannot proceed.
            return;
        }
        // Update the current dataframe to reflect the selection.
        this._dataframe.traceset = subDataframe.traceset;
        this._dataframe.header = subDataframe.header;
        this._dataframe.traceMetadata = subDataframe.traceMetadata;
        this.updateTracePointMetadata(subDataframe.traceMetadata);
        if (replot) {
            this.AddPlotLines();
        }
    }
    /**
   * Determines whether the frontend should operate in Legacy Mode (ChromePerf)
   * or Database Mode for anomaly operations.
   *
   * It replicates the backend's `preferLegacy` logic by checking the dual-mode
   * flags and the `fetch_anomalies_from_sql` cookie.
   *
   * @returns true if Legacy Mode should be used, false for Database Mode.
   */ isLegacyMode() {
        return !window.perf.fetch_anomalies_from_sql;
    }
    enableTooltip(pointDetails, commits, fixTooltip) {
        var _tooltipElem, _this_selectedRange, _this_dfRepo_value, _this_dfRepo_value1, _this_dfRepo_value2, _prevCommitPos, _this_dfRepo_value3;
        // explore-simple-sk is used multiple times on the multi-graph view. To
        // make sure that appropriate chart-tooltip-sk element is selected, we
        // start the search from the explore-simple-sk that the user is hovering/
        // clicking on
        const tooltipElem = (0, _dom.$$)('chart-tooltip-sk', this);
        (_tooltipElem = tooltipElem) === null || _tooltipElem === void 0 ? void 0 : _tooltipElem.reset();
        const x = (((_this_selectedRange = this.selectedRange) === null || _this_selectedRange === void 0 ? void 0 : _this_selectedRange.begin) || 0) + pointDetails.x;
        let commitDate = new Date();
        // Store the hashes of the first two commits in the range.
        // Show the commit hashes in the tooltip without having to refetch.
        let hashes = [];
        // Ensure that at least 2 hashes exist and use null if needed.
        if (commits && commits.length >= 2) {
            var _commits_, _commits_1;
            var _commits__hash, _commits__hash1;
            hashes = [
                (_commits__hash = (_commits_ = commits[0]) === null || _commits_ === void 0 ? void 0 : _commits_.hash) !== null && _commits__hash !== void 0 ? _commits__hash : '',
                (_commits__hash1 = (_commits_1 = commits[1]) === null || _commits_1 === void 0 ? void 0 : _commits_1.hash) !== null && _commits__hash1 !== void 0 ? _commits__hash1 : ''
            ];
        }
        const commit = commits ? commits[1] : null;
        if (commit === null) {
            const chart = this.googleChartPlot.value;
            commitDate = chart.getCommitDate(x);
        } else {
            commitDate = new Date(commit.timestamp * 1000);
        }
        const traceName = pointDetails.name;
        const header = ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header) || null;
        const commitPosition = this.dfRepo.value.dataframe.header[x].offset;
        const chart = this.googleChartPlot.value;
        const color = chart.getTraceColor(traceName);
        const prevCommitPos = this.getPreviousCommit(x, traceName);
        const anomaly = ((_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.getAnomaly(traceName, commitPosition)) || null;
        const trace = ((_this_dfRepo_value2 = this.dfRepo.value) === null || _this_dfRepo_value2 === void 0 ? void 0 : _this_dfRepo_value2.dataframe.traceset[traceName]) || [];
        this.startCommit = ((_prevCommitPos = prevCommitPos) === null || _prevCommitPos === void 0 ? void 0 : _prevCommitPos.toString()) || '';
        this.endCommit = commitPosition.toString();
        if (!this.disablePointLinks) {
            tooltipElem.loadPointLinks(commitPosition, prevCommitPos, traceName, window.perf.keys_for_commit_range, window.perf.keys_for_useful_links, this.commitLinks).then((links)=>{
                this.commitLinks = links;
            }).catch((errorMessage)=>{
                console.error('Error loading point links:', errorMessage);
            });
        }
        // TODO(b/370804498): To be refactored into google plot / dataframe.
        // The anomaly data is indirectly referenced from simple-plot, and the anomaly data gets
        // updated in place in triage popup. This may cause the data inconsistency to manipulate
        // data in several places.
        // Ideally, dataframe_context should nudge anomaly data.
        // Map an anomaly ID to a list of Nudge Entries.
        // TODO(b/375678060): Reflect anomaly coordinate changes unto summary bar.
        let nudgeList = [];
        if (anomaly) {
            var _this_selectedRange1;
            // This is only to be backward compatible with anomaly data in simple-plot.
            const anomalyData = {
                anomaly: anomaly,
                x: commitPosition,
                y: pointDetails.y,
                highlight: false
            };
            const dfHeader = this.dfRepo.value.dataframe.header;
            const dfTrace = this.dfRepo.value.dataframe.traceset[traceName];
            const xOffset = ((_this_selectedRange1 = this.selectedRange) === null || _this_selectedRange1 === void 0 ? void 0 : _this_selectedRange1.begin) || 0;
            const isLegacy = this.isLegacyMode();
            nudgeList = (0, _nudgeutil.calculateNudgeList)(dfTrace, dfHeader, x, anomalyData, NUDGE_RANGE, xOffset, isLegacy);
        }
        const closeBtnAction = fixTooltip ? ()=>{
            this.closeTooltip();
        } : ()=>{};
        let buganizerId = 0;
        const userIssueMap = (_this_dfRepo_value3 = this.dfRepo.value) === null || _this_dfRepo_value3 === void 0 ? void 0 : _this_dfRepo_value3.userIssues;
        if (userIssueMap && Object.keys(userIssueMap).length > 0) {
            const buganizerTraces = userIssueMap[traceName];
            if (buganizerTraces !== null && buganizerTraces !== undefined) {
                var _buganizerTraces_commitPosition;
                buganizerId = ((_buganizerTraces_commitPosition = buganizerTraces[commitPosition]) === null || _buganizerTraces_commitPosition === void 0 ? void 0 : _buganizerTraces_commitPosition.bugId) || 0;
            }
        }
        let unitValue = '';
        traceName.split(',').forEach((test)=>{
            if (test.startsWith('unit')) {
                unitValue = test.split('=')[1];
            }
        });
        // Get the legend index for the test name, subtract 2 to skip date/number.
        const legendIndex = this.dfRepo.value && this.dfRepo.value.data ? this.dfRepo.value.data.getColumnIndex(traceName) - 2 : -1;
        const getLegendData = (0, _traceset.getLegend)(this.dfRepo.value.data);
        let testName = (0, _traceset.legendFormatter)(getLegendData)[legendIndex];
        // Get index of legend and remove unit to display in tooltip.
        if (unitValue.length > 0) {
            testName = testName.replace('/' + unitValue, '');
        }
        // Populate the commit-range-sk element.
        // Backwards compatibility to tooltip load() function.
        const commitRangeSk = new _commitrangesk.CommitRangeSk();
        commitRangeSk.autoload = false;
        commitRangeSk.trace = trace;
        commitRangeSk.header = header;
        commitRangeSk.hashes = hashes;
        commitRangeSk.commitIndex = x;
        if (anomaly !== null && anomaly.bug_id > 0) {
            this.bugId = anomaly.bug_id.toString();
        } else {
            this.bugId = '';
        }
        this.constructTestPath(traceName);
        const preloadBisectInputs = {
            testPath: this.testPath,
            startCommit: this.startCommit,
            endCommit: this.endCommit,
            bugId: this.bugId,
            anomalyId: this.selectedAnomaly ? String(this.selectedAnomaly.id) : '',
            story: this.story ? this.story : ''
        };
        const params = (0, _paramtools.fromKey)(traceName);
        const preloadTryJobInputs = {
            testPath: this.testPath,
            baseCommit: this.startCommit,
            endCommit: this.endCommit,
            story: this.story ? this.story : '',
            configuration: params.bot || '',
            benchmark: params.benchmark || ''
        };
        tooltipElem.moveTo({
            x: pointDetails.xPos,
            y: pointDetails.yPos
        });
        tooltipElem.setBisectInputParams(preloadBisectInputs);
        tooltipElem.setTryJobInputParams(preloadTryJobInputs);
        tooltipElem.load(legendIndex, testName, traceName, unitValue, pointDetails.y, commitDate, commitPosition, buganizerId, anomaly, nudgeList, commit, fixTooltip, commitRangeSk, closeBtnAction, color, this.user);
        if (window.perf.show_json_file_display) {
            tooltipElem.loadJsonResource(commitPosition, traceName);
        }
    }
    // if the user's cursor leaves the graph, close the tooltip
    // unless the tooltip is 'fixed', meaning the user has anchored it.
    mouseLeave() {
        if (!this.tooltipSelected) {
            this.closeTooltip();
        }
    }
    clearTooltip() {
        var _tooltipElem;
        const tooltipElem = (0, _dom.$$)('chart-tooltip-sk', this);
        (_tooltipElem = tooltipElem) === null || _tooltipElem === void 0 ? void 0 : _tooltipElem.reset();
    }
    /** Hides the tooltip. Generally called when mouse moves out of the graph */ closeTooltip() {
        var _tooltipElem, // unselect all selected item on the chart
        _this_googleChartPlot_value, _this_plotSummary_value;
        const tooltipElem = (0, _dom.$$)('chart-tooltip-sk', this);
        if (!tooltipElem || tooltipElem.index === -1) {
            return;
        }
        tooltipElem.moveTo(null);
        if (this.tooltipSelected) {
            this.clearSelectedState();
        }
        this.tooltipSelected = false;
        (_tooltipElem = tooltipElem) === null || _tooltipElem === void 0 ? void 0 : _tooltipElem.reset();
        (_this_googleChartPlot_value = this.googleChartPlot.value) === null || _this_googleChartPlot_value === void 0 ? void 0 : _this_googleChartPlot_value.unselectAll();
        if ((_this_plotSummary_value = this.plotSummary.value) === null || _this_plotSummary_value === void 0 ? void 0 : _this_plotSummary_value.selectedTrace) {
            this.plotSummary.value.selectedTrace = '';
        }
        this.render();
    }
    /** Highlight a trace when it is clicked on. */ // TODO(b/447094435) I suspect this function has no effect due to rerendering
    // and calls to google-chart. Need to verify.
    traceSelected({ detail }) {
        var _this_selectedRange, _this_dfRepo_value_dataframe_header_x, _this_dfRepo_value, _this_dfRepo_value1, _this_dfRepo_value2, _this_dfRepo_value3;
        // If traces are rendered and summary bar is enabled, show
        // summary for the trace clicked on the graph.
        if (this.summaryOptionsField.value) {
            const option = this.traceIdSummaryOptionMap.get(detail.name) || '';
            this.summaryOptionsField.value.selectedItems = option ? [
                option
            ] : [];
        }
        const selected = ((_this_selectedRange = this.selectedRange) === null || _this_selectedRange === void 0 ? void 0 : _this_selectedRange.begin) || 0;
        const x = selected + detail.x;
        if (x < 0) {
            return;
        }
        // loop backwards from x until you get the next
        // non MISSING_DATA_SENTINEL point.
        const commit = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : (_this_dfRepo_value_dataframe_header_x = _this_dfRepo_value.dataframe.header[x]) === null || _this_dfRepo_value_dataframe_header_x === void 0 ? void 0 : _this_dfRepo_value_dataframe_header_x.offset;
        if (!commit) {
            return;
        }
        const commits = [
            commit
        ];
        // Find all the commit ids between the commit that was clicked on, and the
        // previous commit on the display, inclusive of the commit that was clicked,
        // and non-inclusive of the previous commit.
        // We always do this, but the response may not contain all the commit info
        // if alerts.DefaultSparse==true, in which case only info for the first
        // commit is returned.
        // First skip back to the next point with data.
        const trace = ((_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.dataframe.traceset[detail.name]) || [];
        const header = ((_this_dfRepo_value2 = this.dfRepo.value) === null || _this_dfRepo_value2 === void 0 ? void 0 : _this_dfRepo_value2.header) || [];
        let prevCommit = (0, _json.CommitNumber)(-1);
        for(let i = x - 1; i >= 0; i--){
            if (trace[i] !== _const.MISSING_DATA_SENTINEL) {
                prevCommit = header[i].offset;
                break;
            }
        }
        if (prevCommit !== -1) {
            for(let c = commit - 1; c > prevCommit; c--){
                commits.push(c);
            }
        }
        var _this_dfRepo_value_getAnomaly;
        // Find if selected point is an anomaly.
        const selected_anomaly = (_this_dfRepo_value_getAnomaly = (_this_dfRepo_value3 = this.dfRepo.value) === null || _this_dfRepo_value3 === void 0 ? void 0 : _this_dfRepo_value3.getAnomaly(detail.name, detail.x)) !== null && _this_dfRepo_value_getAnomaly !== void 0 ? _this_dfRepo_value_getAnomaly : null;
        this.selectedAnomaly = selected_anomaly;
        const paramset = (0, _json.ParamSet)({});
        let paramsets = [];
        const params = (0, _paramtools.fromKey)(detail.name);
        Object.keys(params).forEach((key)=>{
            paramset[key] = [
                params[key]
            ];
        });
        paramsets = [
            paramset
        ];
        this.render();
        this._state.selected.name = detail.name;
        this._state.selected.commit = commit;
        this._stateHasChanged();
        const parts = [];
        this.story = this.getLastSubtest(paramsets[0])[0];
        if (paramsets[0].master && paramsets[0].master.length > 0) {
            parts.push(paramsets[0].master[0]);
        }
        if (paramsets[0].bot && paramsets[0].bot.length > 0) {
            parts.push(paramsets[0].bot[0]);
        }
        if (paramsets[0].benchmark && paramsets[0].benchmark.length > 0) {
            parts.push(paramsets[0].benchmark[0]);
        }
        if (paramsets[0].test && paramsets[0].test.length > 0) {
            parts.push(paramsets[0].test[0]);
        }
        parts.push(this.story);
        this.testPath = parts.join('/');
        this.startCommit = prevCommit.toString();
        this.endCommit = commit.toString();
        if (selected_anomaly !== null && selected_anomaly.bug_id !== -1) {
            this.bugId = selected_anomaly.bug_id.toString();
        } else {
            this.bugId = '';
        }
        // Open the details section if it is currently collapsed
        if (!this.navOpen) {
            var _this_collapseButton;
            (_this_collapseButton = this.collapseButton) === null || _this_collapseButton === void 0 ? void 0 : _this_collapseButton.click();
        }
    }
    clearSelectedState() {
        // Switch back to the params tab since we are about to hide the details tab.
        if (this.detailTab) {
            this.detailTab.selected = PARAMS_TAB_INDEX;
        }
        if (this.logEntry) {
            this.logEntry.textContent = '';
        }
        this._state.selected = defaultPointSelected();
        this._stateHasChanged();
    }
    /**
   * Fixes up the time ranges in the state that came from query values.
   *
   * It is possible for the query URL to specify just the begin or end time,
   * which may end up giving us an inverted time range, i.e. end < begin.
   */ rationalizeTimeRange(state) {
        const defaultRangeS = this.getDefaultRange();
        const now = Math.floor(Date.now() / 1000);
        let currentBegin = Math.round(state.begin);
        let currentEnd = Math.round(state.end);
        // Default application should only happen if the state is uninitialized.
        // In the ExploreMultiSk context, begin and end should always be > -1.
        if (currentBegin === -1 && currentEnd === -1) {
            console.warn('ExploreSimpleSk: begin and end were not initialized.');
            currentEnd = now;
            currentBegin = now - defaultRangeS;
        } else if (currentBegin === -1) {
            console.warn('ExploreSimpleSk: begin was not initialized.');
            currentBegin = currentEnd - defaultRangeS;
        } else if (currentEnd === -1) {
            console.warn('ExploreSimpleSk: end was not initialized.');
            currentEnd = currentBegin + defaultRangeS;
        }
        // Ensure end is not in the future.
        if (currentEnd > now) {
            currentEnd = now;
        }
        // Ensure end is not before begin.
        if (currentEnd <= currentBegin) {
            currentEnd = currentBegin + defaultRangeS;
            if (currentEnd > now) {
                currentEnd = now;
                if (currentBegin >= currentEnd) {
                    currentBegin = currentEnd - defaultRangeS;
                }
            }
        }
        state.begin = currentBegin;
        state.end = currentEnd;
        return state;
    }
    // Transfer trace name to test path that used for bisect job parameter
    constructTestPath(traceName) {
        // Extract story (subtest) information
        const params = (0, _paramtools.fromKey)(traceName);
        this.story = this.getLastSubtest(params);
        // Construct the testPath
        const parts = [];
        if (params.master) {
            parts.push(params.master);
        }
        if (params.bot) {
            parts.push(params.bot);
        }
        if (params.benchmark) {
            parts.push(params.benchmark);
        }
        if (params.test) {
            parts.push(params.test);
        }
        // Only add subtests if they are not the same as story, up to 4.
        if (params.subtest_1 && params.subtest_1 !== this.story) {
            parts.push(params.subtest_1);
        }
        if (params.subtest_2 && params.subtest_2 !== this.story) {
            parts.push(params.subtest_2);
        }
        if (params.subtest_3 && params.subtest_3 !== this.story) {
            parts.push(params.subtest_3);
        }
        if (params.subtest_4 && params.subtest_4 !== this.story) {
            parts.push(params.subtest_4);
        }
        parts.push(this.story);
        this.testPath = parts.join('/');
    }
    /**
   * Handler for the event when the remove paramset value button is clicked
   * @param e Remove event
   */ paramsetRemoveClick(e) {
        var // Remove the specified value from the query
        _this_query;
        (_this_query = this.query) === null || _this_query === void 0 ? void 0 : _this_query.removeKeyValue(e.detail.key, e.detail.value);
    }
    /**
   * Handler for the event when the paramset checkbox is clicked.
   * @param e Checkbox click event
   */ paramsetKeyCheckboxClick(e) {
        var _this_googleChartPlot_value;
        (_this_googleChartPlot_value = this.googleChartPlot.value) === null || _this_googleChartPlot_value === void 0 ? void 0 : _this_googleChartPlot_value.updateChartForParam(e.detail.key, e.detail.values, e.detail.selected);
    }
    /**
   * Handler for the event when the paramset checkbox is clicked.
   * @param e Checkbox click event
   */ paramsetCheckboxClick(e) {
        var _this_googleChartPlot_value;
        (_this_googleChartPlot_value = this.googleChartPlot.value) === null || _this_googleChartPlot_value === void 0 ? void 0 : _this_googleChartPlot_value.updateChartForParam(e.detail.key, [
            e.detail.value
        ], e.detail.selected);
    }
    AddPlotLines() {
        var _this_dfRepo_value, _this_dfRepo_value1;
        const dt = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.data;
        const df = (_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.dataframe;
        const shouldAddSummaryOptions = this._state.plotSummary && df !== undefined && dt !== undefined;
        if (shouldAddSummaryOptions) {
            this.addPlotSummaryOptions(df, dt);
        }
    }
    getTraces(dt) {
        // getLegend returns trace Ids which are not common in all the graphs.
        // Since it is an object we convert it to the standard key format a=A,b=B,
        // so that it could be fed to the traceFormatter.
        //
        // Also note that some values in the legend object has "untitled_key" as value which is
        // used to signify a trace not having any values for a particular param.
        // We ignore this.
        const shortTraceIds = [];
        (0, _traceset.getLegend)(dt).forEach((traceObject)=>{
            let shortTraceId = '';
            const to = traceObject;
            Object.keys(to).forEach((k)=>{
                const v = String(to[k]);
                shortTraceId += v !== 'untitled_key' ? `${k}=${v},` : '';
            });
            // Add an extra comma at the beginning to make sure
            // the key is in standard ,a=1,b=2,c=3, format
            if (shortTraceId !== '') {
                shortTraceId = `,${shortTraceId}`;
            }
            let formattedShortTrace = '';
            if (shortTraceId !== '') {
                formattedShortTrace = this.traceFormatter.formatTrace((0, _paramtools.fromKey)(shortTraceId));
            }
            // Since this text is just the uncommon part of trace Id we want to remove
            // the label from the formatted trace id so the user doesn't get confused.
            formattedShortTrace = formattedShortTrace.replace('Trace ID: ', '');
            shortTraceIds.push(formattedShortTrace);
        });
        return shortTraceIds;
    }
    /**
   * Adds the option list for the plot summary selection.
   * @param df The dataframe object from dataframe context.
   * @param df The dataTable object from dataframe context.
   */ addPlotSummaryOptions(df, dt) {
        if (!this.summaryOptionsField.value) {
            return;
        }
        if ((0, _traceset.isSingleTrace)(dt)) {
            this.summaryOptionsField.value.style.display = 'none';
            return;
        }
        const titleObj = (0, _traceset.getTitle)(dt);
        let commonTitle = '';
        for (const [key, value] of Object.entries(titleObj)){
            commonTitle += `${key}=${value},`;
        }
        // Add an extra comma at the beginning to make sure
        // the key is in standard ,a=1,b=2,c=3, format
        if (commonTitle !== '') {
            commonTitle = `,${commonTitle}`;
        }
        const shortTraceIds = this.getTraces(dt);
        const displayOptions = [];
        const traceIds = Object.keys(df.traceset);
        shortTraceIds.forEach((shortTraceId, i)=>{
            const traceId = traceIds[i];
            const op = `...${shortTraceId}`;
            // These maps are useful to find summary drop down options from the trace key
            // and vice versa. The trace key's format is constant across the tool.
            // Hence these maps come in handy for that purpose. They're used primarily
            // when the summary drop down changes and when a trace is selected from
            // the graph.
            this.summaryOptionTraceMap.set(op, traceId);
            this.traceIdSummaryOptionMap.set(traceId, op);
            displayOptions.push(op);
        });
        const formattedTitle = this.traceFormatter.formatTrace((0, _paramtools.fromKey)(commonTitle));
        this.summaryOptionsField.value.helperText = formattedTitle;
        this.summaryOptionsField.value.options = displayOptions;
        this.summaryOptionsField.value.label = 'Legend ';
    }
    paramsetKeyValueClick(e) {
        const keys = [];
        Object.keys(this._dataframe.traceset).forEach((key)=>{
            if (_matches(key, e.detail.key, e.detail.value)) {
                keys.push(key);
            }
        });
        this.render();
    }
    closeHelp() {
        this.helpDialog.close();
    }
    /** Create a FrameRequest that will fill in data specified by this._state.begin and end,
   *  but is not yet present in this._dataframe.
   */ requestFrameBodyDeltaFromState() {
        return this.requestFrameBodyFullFromState();
    }
    /** Create a FrameRequest that will re-create the current state of the page. */ requestFrameBodyFullFromState() {
        return this.requestFrameBodyFullForRange(this._state.begin, this._state.end);
    }
    /**
   * Create a FrameRequest that recreates the current state of the page
   * for the given range.
   * @param begin Start time.
   * @param end End time.
   * @returns FrameRequest object.
   */ requestFrameBodyFullForRange(begin, end) {
        return {
            begin: begin,
            end: end,
            num_commits: this._state.numCommits,
            request_type: this._state.requestType,
            formulas: this._state.formulas,
            queries: this._state.queries,
            keys: this._state.keys,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            pivot: (0, _pivotutil.validatePivotRequest)(this._state.pivotRequest) === '' ? this._state.pivotRequest : null,
            disable_filter_parent_traces: this._state.disable_filter_parent_traces || this._state.queries.some((q)=>q.includes(_const.MISSING_VALUE_SENTINEL))
        };
    }
    /** Reload all the queries/formulas on the given time range. */ rangeChangeImpl() {
        if (!this._state) {
            return;
        }
        if (this._state.formulas.length === 0 && this._state.queries.length === 0 && this._state.keys === '') {
            return;
        }
        const body = this.requestFrameBodyDeltaFromState();
        if (body.begin === body.end) {
            return;
        }
        if (this.commitTime) {
            this.commitTime.textContent = '';
        }
        const switchToTab = body.formulas.length > 0 || body.queries.length > 0 || body.keys !== '';
        this.requestFrame(body).then(async (json)=>{
            if (json === null || json === undefined) {
                (0, _errorMessage.errorMessage)('Failed to find any matching traces.', 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.NOT_FOUND.toString()
                });
                return;
            }
            return await this.UpdateWithFrameResponse(json, body, switchToTab, null, true, true);
        }).catch((msg)=>{
            if (msg instanceof _dataservice.DataServiceError) {
                (0, _errorMessage.errorMessage)(msg.message, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: msg.status.toString()
                });
            } else {
                (0, _errorMessage.errorMessage)(msg, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                });
            }
        });
    }
    /**
   * UpdateWithFrameResponse updates the explore element with the given frame response.
   * @param frameResponse FrameResponse object containing the data frame.
   * @param frameRequest Frame Request object containing the corresponding backend request.
   * @param switchToTab Whether switch should be done.
   */ async UpdateWithFrameResponse(frameResponse, frameRequest, switchToTab, selectedRange = null, extendRange = true, replaceAnomalies = false) {
        var _this_dfRepo_value;
        this.render();
        const dfRepo = this.dfRepo.value;
        if (!dfRepo) {
            console.error('DataFrameRepository is not available.');
            return;
        }
        await ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.resetWithDataframeAndRequest(frameResponse.dataframe, frameResponse.anomalymap, frameRequest, replaceAnomalies));
        // Code previously in .then() now runs after await.
        const loadingMore = this.addTraces(frameResponse, switchToTab, selectedRange, extendRange);
        this.updateTracePointMetadata(frameResponse.dataframe.traceMetadata);
        this.updateTitle();
        if (isValidSelection(this._state.selected)) {
            const e = selectionToEvent(this._state.selected, this._dataframe.header);
            // If the range has moved to no longer include the selected commit then
            // clear the selection.
            if (e.detail.x === -1) {
                this.clearSelectedState();
            } else {
                this.traceSelected(e);
            }
        }
        this.render();
        return await loadingMore;
    }
    /**
   * Add traces to the display. Always called from within the
   * this._requestFrame() callback.
   *
   * There are three distinct cases of incoming FrameResponse to handle in this method:
   * - user panned left to incrementally load older data points to an existing query
   * - user panned right to incrementally load newer data points to an existing query
   * - a new page load, user made an entirely new query, or made a zoom-out request that
   *   includes both newer and older data points than are currently loaded.
   * The first two cases mean we can merge the existing dataframe with the incoming dataframe.
   * The third case means we need to replace the existing dataframe with the incoming dataframe.
   *
   * @param {Object} json - The parsed JSON returned from the server.
   * otherwise replace them all with the new ones.
   * @param {Boolean} tab - If true then switch to the Params tab.
   */ async addTraces(json, tab, selectedRange = null, loadExtendedRange = true) {
        const dataframe = json.dataframe;
        if (dataframe.traceset === null || Object.keys(dataframe.traceset).length === 0) {
            this.displayMode = 'display_query_only';
            return;
        }
        if (dataframe.header.length * Object.keys(dataframe.traceset).length > DATAPOINT_THRESHOLD) {
            (0, _errorMessage.errorMessage)('Large amount of data requsted, performance may be affected.', 2000, {
                source: EXPLORE_SIMPLE_PAGE_SOURCE,
                errorCode: _httpstatuscodes.StatusCodes.OK.toString()
            });
        }
        this.tracesRendered = true;
        this.displayMode = json.display_mode;
        if (this.displayMode === 'display_pivot_table') {
            this.pivotTable.removeAttribute('disable_validation');
            this.pivotTable.set(dataframe, this.pivotControl.pivotRequest, this._state.queries[0], this._state.sort);
            return;
        }
        if (selectedRange === null) {
            selectedRange = this.calculateSelectionFromState();
        }
        this.updateSelectedRangeWithUpdatedDataframe(selectedRange, this._state.domain);
        const googleChart = this.googleChartPlot.value;
        if (googleChart) {
            // Populate the xbar if present.
            if (this.state.xbaroffset !== -1) {
                googleChart.xbar = this.state.xbaroffset;
            }
            googleChart.domain = this.state.domain;
        }
        if (this.state.use_titles) {
            this.updateTitle();
        }
        // Populate the paramset element.
        if (this.paramset) {
            this.paramset.paramsets = [
                dataframe.paramset
            ];
        }
        if (tab && this.detailTab) {
            var // Asynchronously fetch the user issues for the rendered traces.
            _this_dfRepo_value;
            this.detailTab.selected = PARAMS_TAB_INDEX;
            (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.getUserIssues(Object.keys(dataframe.traceset), selectedRange.begin, selectedRange.end).then((_)=>{
                this.updateSelectedRangeWithUpdatedDataframe(selectedRange, this.state.domain);
            });
        }
        this._renderedTraces();
        if (this._state.plotSummary) {
            if (this.state.doNotQueryData || !loadExtendedRange) {
                var // The data is supposed to be already loaded.
                // Let's simply make the selection on the summary.
                _this_plotSummary_value;
                this.render();
                (_this_plotSummary_value = this.plotSummary.value) === null || _this_plotSummary_value === void 0 ? void 0 : _this_plotSummary_value.SelectRange(selectedRange);
            } else {
                return await this.loadExtendedRangeData();
            }
        }
    }
    calculateSelectionFromState() {
        var _this_dfRepo_value, _this_dfRepo_value1, _this_dfRepo_value2;
        if (this._state.domain === 'date') {
            return (0, _dataframe.range)(this._state.begin, this._state.end);
        }
        const header = ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header) || [];
        const beginIndex = this.getCommitIndex(this._state.begin, 'timestamp');
        const endIndex = this.getCommitIndex(this._state.end, 'timestamp', true);
        let beginOffset = header && header.length > 0 ? header[0].offset : 0;
        let endOffset = header && header.length > 0 ? header[header.length - 1].offset : 0;
        if (beginIndex !== -1 && ((_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.header[beginIndex])) {
            beginOffset = this.dfRepo.value.header[beginIndex].offset;
        }
        if (endIndex !== -1 && ((_this_dfRepo_value2 = this.dfRepo.value) === null || _this_dfRepo_value2 === void 0 ? void 0 : _this_dfRepo_value2.header[endIndex])) {
            endOffset = this.dfRepo.value.header[endIndex].offset;
        }
        return (0, _dataframe.range)(beginOffset, endOffset);
    }
    /**
   * Loads extended range data for the plot summary.
   * @returns A Promise that resolves when the extended range data is loaded.
   */ async loadExtendedRangeData() {
        var _this_dfRepo_value, _this_dfRepo_value1, _this_dfRepo_value2, _this_dfRepo_value3;
        const header = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.header;
        if (!header) {
            return;
        }
        let extendRange = 3 * monthInSec;
        // Large amount of traces, limit the range extension.
        if (((_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.traces) && Object.keys(this.dfRepo.value.traces).length > 10) {
            extendRange = monthInSec;
        }
        const promises = [
            (_this_dfRepo_value2 = this.dfRepo.value) === null || _this_dfRepo_value2 === void 0 ? void 0 : _this_dfRepo_value2.extendRange(-extendRange),
            (_this_dfRepo_value3 = this.dfRepo.value) === null || _this_dfRepo_value3 === void 0 ? void 0 : _this_dfRepo_value3.extendRange(extendRange)
        ];
        await Promise.allSettled(promises);
        const currentRange = this.calculateSelectionFromState();
        // Only fetch data in the background. We force the graph and the summary
        // box to respect the exact range the user originally requested.
        this.updateSelectedRangeWithUpdatedDataframe(currentRange, this.state.domain, false);
        // Ensure the plot summary's selection box reflects the EXACT requested range,
        // not the artificially expanded 100-point range.
        if (this.plotSummary.value) {
            this.plotSummary.value.SelectRange(currentRange);
            this.plotSummary.value.selectedValueRange = currentRange;
        }
        this.dataLoading = false;
    }
    /**
   * Plot the traces that match either the current query or the current formula,
   * depending on the value of plotType.
   *
   * @param replace - If true then replace all the traces with ones
   * that match this query, otherwise add them to the current traces being
   * displayed.
   *
   * @param plotType - The type of traces being added.
   */ add(replace, plotType) {
        const q = this.query.current_query;
        const f = this.formula.value;
        let j = this.json.value;
        if (plotType === 'json' && j === '') {
            // If JSON is empty, check URL.
            const currentUrl = new URL(window.location.href);
            const jsonParam = currentUrl.searchParams.get('json');
            if (jsonParam) {
                j = jsonParam;
                // Populate the text area so the user sees it.
                this.json.value = j;
            }
        }
        this.addFromQueryOrFormula(replace, plotType, q, f, j);
    }
    /** Create a FrameRequest for just a single query or formula. */ requestFrameBodyForTrace(plotType, q, f, j) {
        let formulas = [];
        let queries = [];
        let keys = '';
        if (plotType === 'formula') {
            formulas = [
                f
            ];
        } else if (plotType === 'query') {
            queries = [
                q
            ];
        } else if (plotType === 'json') {
            const graphConfig = JSON.parse(j);
            // TODO(b/381139433): Support multiple graphs.
            if (graphConfig.graphs && graphConfig.graphs.length > 0) {
                queries = graphConfig.graphs[0].queries || [];
                formulas = graphConfig.graphs[0].formulas || [];
                keys = graphConfig.graphs[0].keys || '';
            }
        }
        return {
            begin: this._state.begin,
            end: this._state.end,
            num_commits: this._state.numCommits,
            request_type: this._state.requestType,
            formulas: formulas,
            queries: queries,
            keys: keys,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            pivot: null,
            disable_filter_parent_traces: this._state.disable_filter_parent_traces || queries.some((q)=>q.includes(_const.MISSING_VALUE_SENTINEL))
        };
    }
    /* Plot the traces that match either the given query or the given formula,
   * depending on the value of plotType.
   *
   * @param replace - If true then replace all the traces with ones that match
   * this query, otherwise add them to the current traces being displayed.
   *
   * @param plotType - The type of traces being added.
   */ async addFromQueryOrFormula(replace, plotType, q, f, j = '', loadExtendedRange = true) {
        if (this.queryDialog !== null) {
            this.queryDialog.close();
        }
        this._dialogOn = false;
        this.dataLoading = true;
        if (plotType === 'query') {
            if (!q || q.trim() === '') {
                (0, _errorMessage.errorMessage)('The query must not be empty.', 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
        } else if (plotType === 'formula') {
            if (f.trim() === '') {
                (0, _errorMessage.errorMessage)('The formula must not be empty.', 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
        } else if (plotType === 'pivot') {
            if (!q || q.trim() === '') {
                (0, _errorMessage.errorMessage)('The query must not be empty.', 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
            const pivotMsg = (0, _pivotutil.validatePivotRequest)(this.pivotControl.pivotRequest);
            if (pivotMsg !== '') {
                (0, _errorMessage.errorMessage)(pivotMsg, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
        } else if (plotType === 'json') {
            if (j.trim() === '') {
                (0, _errorMessage.errorMessage)('The JSON must not be empty.', 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
            try {
                JSON.parse(j);
            } catch (e) {
                (0, _errorMessage.errorMessage)(`Invalid JSON: ${e}`, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
                });
                return;
            }
        } else {
            (0, _errorMessage.errorMessage)('Unknown plotType', 0, {
                source: EXPLORE_SIMPLE_PAGE_SOURCE,
                errorCode: _httpstatuscodes.StatusCodes.BAD_REQUEST.toString()
            });
            return;
        }
        if (this.range !== null && !this.useTestPicker) {
            // Only lengthen the time range, do not shorten.
            if (this.range.state.begin < this._state.begin) {
                this._state.begin = this.range.state.begin;
            }
            if (this.range.state.end > this._state.end) {
                this._state.end = this.range.state.end;
            }
            this._state.numCommits = this.range.state.num_commits;
            this._state.requestType = this.range.state.request_type;
        }
        this._state.sort = '';
        const createFromScratch = replace || plotType === 'pivot' || plotType === 'json' || this._state.formulas.length === 0 && this._state.queries.length === 0;
        if (createFromScratch) {
            this.removeAll(true);
        }
        this._state.pivotRequest = defaultPivotRequest();
        if (plotType === 'query') {
            if (this._state.queries.length === 1 && this._state.queries[0] !== q) {
                this._state.queries = [];
            }
            if (this._state.queries.indexOf(q) === -1) {
                this._state.queries.push(q);
            }
        } else if (plotType === 'formula') {
            if (this._state.formulas.indexOf(f) === -1) {
                this._state.formulas.push(f);
            }
        } else if (plotType === 'pivot') {
            if (this._state.queries.indexOf(q) === -1) {
                this._state.queries.push(q);
            }
            this._state.pivotRequest = this.pivotControl.pivotRequest;
        } else if (plotType === 'json') {
            const graphConfig = JSON.parse(j);
            // TODO(b/381139433): Support multiple graphs.
            if (graphConfig.graphs && graphConfig.graphs.length > 0) {
                this._state.queries = graphConfig.graphs[0].queries || [];
                this._state.formulas = graphConfig.graphs[0].formulas || [];
                this._state.keys = graphConfig.graphs[0].keys || '';
            }
        }
        this.applyQueryDefaultsIfMissing();
        this._stateHasChanged();
        this.updateTestPickerUrl();
        try {
            if (createFromScratch) {
                const body = this.requestFrameBodyFullFromState();
                return this.requestFrame(body).then(async (json)=>{
                    if (json) {
                        return await this.UpdateWithFrameResponse(json, body, /*switchToTab=*/ true, this.getSelectedRange(), loadExtendedRange, true);
                    }
                });
            } else {
                const requestNewData = this.requestFrameBodyForTrace(plotType, q, f, j);
                const requestAllData = this.requestFrameBodyFullFromState();
                return this.requestFrame(requestNewData).then(async (json)=>{
                    if (!json) {
                        return;
                    }
                    // Merge new data with the existing state.
                    const frameResponse = json;
                    const newDf = frameResponse.dataframe;
                    const fullDf = this.getDataFrame();
                    const mergedDataFrame = (0, _index.join)(fullDf, newDf);
                    frameResponse.dataframe = mergedDataFrame;
                    // Don't merge anomalies because DataFrameRepository already does that.
                    return await this.UpdateWithFrameResponse(frameResponse, requestAllData, /*switchToTab=*/ true, this.getSelectedRange(), loadExtendedRange);
                });
            }
        } catch (error) {
            // errorMessage is likely already called by requestFrame or its callees.
            console.error('Error in addFromQueryOrFormula during requestFrame:', error);
        }
    }
    /**
   * updateTracePointMetadata populates the commit links from the trace metadata
   * in the response.
   */ async updateTracePointMetadata(traceMetadatas) {
        if (traceMetadatas === null) {
            return;
        }
        // Use a Map for efficient lookups of existing commit links by a composite key.
        // The key will be a string like "cid-traceid".
        const uniqueLinksMap = new Map();
        // Populate the map with links already present in the class member this.commitLinks.
        // This ensures we don't add duplicates from previous updates.
        for (const link of this.commitLinks){
            if (link === null) continue;
            const identifier = `${link.cid}-${link.traceid}`;
            uniqueLinksMap.set(identifier, link);
        }
        // Iterate through the new traceMetadatas.
        for (const traceMetadata of traceMetadatas){
            if (traceMetadata.commitLinks !== null) {
                // Iterate through the commit links within the current traceMetadata.
                for(const commitnumStr in traceMetadata.commitLinks){
                    const commitnum = parseInt(commitnumStr);
                    const traceid = traceMetadata.traceid; // traceid is directly on traceMetadata
                    const identifier = `${commitnum}-${traceid}`;
                    // Check if this specific link (cid-traceid pair) already exists.
                    if (!uniqueLinksMap.has(identifier)) {
                        const displayUrls = {};
                        const displayTexts = {};
                        // Populate displayUrls and displayTexts from the current commit's links.
                        const linksForCommit = traceMetadata.commitLinks[commitnum];
                        if (linksForCommit) {
                            // Ensure linksForCommit is not null/undefined
                            for(const linkKey in linksForCommit){
                                const linkObj = linksForCommit[linkKey];
                                displayTexts[linkKey] = linkObj.Text;
                                displayUrls[linkKey] = linkObj.Href;
                            }
                        }
                        const commitLink = {
                            cid: commitnum,
                            traceid: traceid,
                            displayUrls: displayUrls,
                            displayTexts: displayTexts
                        };
                        // Add the new unique link to the map.
                        uniqueLinksMap.set(identifier, commitLink);
                    }
                }
            }
        }
        // Replace the class member with the newly built unique list from the map's values.
        this.commitLinks = Array.from(uniqueLinksMap.values());
    }
    // take a query string, and update the parameters with default values if needed
    applyDefaultsToQuery(queryString) {
        var _this__defaults;
        const paramSet = (0, _query.toParamSet)(queryString);
        var _this__defaults_default_param_selections;
        let defaultParams = (_this__defaults_default_param_selections = (_this__defaults = this._defaults) === null || _this__defaults === void 0 ? void 0 : _this__defaults.default_param_selections) !== null && _this__defaults_default_param_selections !== void 0 ? _this__defaults_default_param_selections : {};
        if (window.perf.remove_default_stat_value) {
            defaultParams = {};
        }
        for(const defaultParamKey in defaultParams){
            if (!(defaultParamKey in paramSet)) {
                paramSet[defaultParamKey] = defaultParams[defaultParamKey];
            }
        }
        return (0, _query.fromParamSet)(paramSet);
    }
    // applyQueryDefaultsIfMissing updates the fields in the state object to
    // specify the default values provided for the instance if they haven't
    // been specified by the user explicitly.
    applyQueryDefaultsIfMissing() {
        var _this__defaults;
        const updatedQueries = [];
        // Check the current query to see if the default params have been specified.
        // If not, add them with the default value in the instance config.
        this._state.queries.forEach((query)=>{
            updatedQueries.push(this.applyDefaultsToQuery(query));
        });
        this._state.queries = updatedQueries;
        // Check if the user has specified the params provided in the default url config.
        // If not, add them to the state object
        for(const urlKey in (_this__defaults = this._defaults) === null || _this__defaults === void 0 ? void 0 : _this__defaults.default_url_values){
            const stringToBool = function(str) {
                return str.toLowerCase() === 'true';
            };
            if (this._userSpecifiedCustomizationParams.has(urlKey) === false) {
                const paramValue = stringToBool(this._defaults.default_url_values[urlKey]);
                switch(urlKey){
                    case 'plotSummary':
                        this._state.plotSummary = paramValue;
                        break;
                    case 'disableMaterial':
                        this._state.disableMaterial = paramValue;
                        break;
                    case 'showZero':
                        this._state.showZero = paramValue;
                        break;
                    case 'useTestPicker':
                        this.useTestPicker = paramValue;
                        break;
                    case 'use_test_picker_query':
                        this._state.use_test_picker_query = paramValue;
                        this.openQueryByDefault = !paramValue;
                        break;
                    case 'enable_chart_tooltip':
                        this._state.enable_chart_tooltip = paramValue;
                        break;
                    case 'use_titles':
                        this._state.use_titles = paramValue;
                        break;
                    case 'disable_filter_parent_traces':
                        this._state.disable_filter_parent_traces = paramValue;
                        break;
                    default:
                        break;
                }
            }
        }
    }
    /**
   * Removes all traces.
   *
   * @param skipHistory  If true then don't update the URL. Used
   * in calls like _normalize() where this is just an intermediate state we
   * don't want in history.
   */ removeAll(skipHistory) {
        var _this_dfRepo_value;
        this._state.formulas = [];
        this._state.queries = [];
        this._state.keys = '';
        this._dataframe.header = [];
        this._dataframe.traceset = (0, _json.TraceSet)({});
        if (this.graphTitle) {
            this.graphTitle.set(null, 0);
        }
        if (this.paramset) {
            this.paramset.paramsets = [];
        }
        if (this.commitTime) {
            this.commitTime.textContent = '';
        }
        if (this.detailTab) {
            this.detailTab.selected = PARAMS_TAB_INDEX;
        }
        this.displayMode = 'display_query_only';
        this.tracesRendered = false;
        this.commitLinks = [];
        this.tooltipSelected = false;
        (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.clear();
        this.closeTooltip();
        this.render();
        if (!skipHistory) {
            this.clearSelectedState();
            this._stateHasChanged();
        }
        this.updateTestPickerUrl();
    }
    createGraphConfigs(traceSet, attribute) {
        const graphConfigs = [];
        Object.keys(traceSet).forEach((key)=>{
            const conf = {
                keys: '',
                formulas: [],
                queries: []
            };
            if (key[0] === ',') {
                conf.queries = [
                    new URLSearchParams((0, _paramtools.fromKey)(key, attribute)).toString()
                ];
            } else {
                if (key.startsWith('special')) {
                    return;
                }
                conf.formulas = [
                    key
                ];
            }
            graphConfigs.push(conf);
        });
        return graphConfigs;
    }
    // TODO(b/377772220): When splitting a chart with multiple traces,
    // this function will perform the split operation on every trace.
    // If a trace is selected, the chart should only split on that trace.
    // If no trace is selected, then default to splitting on every trace.
    async splitByAttribute({ detail }) {
        const graphConfigs = this.createGraphConfigs(this._dataframe.traceset, detail.attribute);
        try {
            const newShortcut = await (0, _graphconfig.updateShortcut)(graphConfigs);
            if (newShortcut === '') {
                return;
            }
            window.open(`/m/?begin=${this._state.begin}&end=${this._state.end}` + `&pageSize=${chartsPerPage}&shortcut=${newShortcut}`, '_self');
        } catch (msg) {
            if (msg instanceof _dataservice.DataServiceError && msg.status === 500) {
                (0, _errorMessage.errorMessage)('Unable to update shortcut.', 2000, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: msg.status.toString()
                });
            } else if (msg instanceof _dataservice.DataServiceError) {
                (0, _errorMessage.errorMessage)(msg.message, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: msg.status.toString()
                });
            } else {
                (0, _errorMessage.errorMessage)(msg);
            }
        }
    }
    removeKeys(keysToRemove, updateShortcut) {
        const toShortcut = [];
        Object.keys(this._dataframe.traceset).forEach((key)=>{
            if (keysToRemove.indexOf(key) !== -1) {
                // Detect if it is a formula being removed.
                if (this._state.formulas.indexOf(key) !== -1) {
                    this._state.formulas.splice(this._state.formulas.indexOf(key), 1);
                }
                return;
            }
            if (updateShortcut) {
                if (key[0] === ',') {
                    toShortcut.push(key);
                }
            }
        });
        // Remove the traces from the traceset so they don't reappear.
        keysToRemove.forEach((key)=>{
            var _this_dfRepo_value;
            if (this._dataframe.traceset[key] !== undefined) {
                delete this._dataframe.traceset[key];
            }
            if (((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe.traceset[key]) !== undefined) {
                var _this_dfRepo_value1, _this_dfRepo_value2;
                (_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? true : delete _this_dfRepo_value1.dataframe.traceset[key];
                if ((_this_dfRepo_value2 = this.dfRepo.value) === null || _this_dfRepo_value2 === void 0 ? void 0 : _this_dfRepo_value2.anomaly) {
                    const newAnomalyMap = _object_spread({}, this.dfRepo.value.anomaly);
                    delete newAnomalyMap[key];
                    this.dfRepo.value.anomaly = newAnomalyMap;
                }
            }
        });
        if (!this.hasData()) {
            this.displayMode = 'display_query_only';
            this.render();
        }
    }
    /**
   * If there are tracesets in the Dataframe and IncludeParams config has been specified, we
   * update the title using only the common parameters of all present traces.
   *
   * If there are less than 3 common parameters, we use the default title.
   */ updateTitle() {
        var _this_dfRepo_value, _this_dfRepo_value1, _this__defaults;
        const traceset = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe.traceset;
        if (traceset === null || traceset === undefined) {
            return;
        }
        const paramset = (_this_dfRepo_value1 = this.dfRepo.value) === null || _this_dfRepo_value1 === void 0 ? void 0 : _this_dfRepo_value1.dataframe.paramset;
        if (paramset === null || paramset === undefined) {
            return;
        }
        const allParams = Object.keys(paramset).sort();
        // If the params are not included in the json config key "include_params",
        // we pull the paramset from the dataframe response.
        // https://skia.googlesource.com/buildbot/+/refs/heads/main/perf/configs/v8-perf.json
        let params = (_this__defaults = this._defaults) === null || _this__defaults === void 0 ? void 0 : _this__defaults.include_params;
        if (params === null || params === undefined) {
            params = allParams;
        }
        const numTraces = Object.keys(traceset).length;
        const computeEntries = (paramList)=>{
            const entries = new Map();
            paramList.forEach((param)=>{
                const uniqueValues = new Set(Object.keys(traceset).map((traceId)=>{
                    const val = (0, _paramtools.fromKey)(traceId)[param];
                    // If the value is missing or empty, map it to DEFAULT_OPTION_LABEL
                    // so it is accounted for.
                    return val === undefined || val === '' ? _testpicker.DEFAULT_OPTION_LABEL : val;
                }));
                let value = uniqueValues.values().next().value;
                if (uniqueValues.size > 1) {
                    value = 'Various';
                }
                if (value !== undefined) {
                    entries.set(param, value);
                }
            });
            return entries;
        };
        const titleEntries = computeEntries(params);
        const rawTitleEntries = computeEntries(allParams);
        if (titleEntries.size >= 3) {
            this.graphTitle.set(titleEntries, numTraces, rawTitleEntries);
        } else {
            this.graphTitle.set(new Map(), numTraces, new Map());
        }
    }
    /** @prop spinning - True if we are waiting to retrieve data from
   * the server.
   */ set spinning(b) {
        this._spinning = b;
        if (b) {
            this.displayMode = 'display_spinner';
        }
        this.render();
    }
    get spinning() {
        return this._spinning;
    }
    /**
   * Requests a new dataframe, where body is a serialized FrameRequest:
   *
   * {
   *    begin:    1448325780,
   *    end:      1476706336,
   *    formulas: ["ave(filter("name=desk_nytimes.skp&sub_result=min_ms"))"],
   *    queries:  [
   *        "name=AndroidCodec_01_original.jpg_SampleSize8",
   *        "name=AndroidCodec_1.bmp_SampleSize8"],
   *    tz:       "America/New_York"
   * };
   *
   * @returns A Promise that resolves with the decoded JSON body
   * of the response once it's available.
   */ async requestFrame(body) {
        if (this._requestId !== '') {
            const err = new Error('There is a pending query already running.');
            (0, _errorMessage.errorMessage)(err.message, 0, {
                source: EXPLORE_SIMPLE_PAGE_SOURCE,
                errorCode: _httpstatuscodes.StatusCodes.CONFLICT.toString()
            });
            return null;
        }
        this._requestId = 'foo';
        this.spinning = true;
        this.dataLoading = true;
        try {
            const jsonResponse = await this.sendFrameRequest(body);
            return jsonResponse;
        } catch (err) {
            // This catches errors from sendFrameRequest (e.g., status !== 'Finished')
            if (this.percent) {
                this.percent.textContent = '';
            }
            this.spinning = false;
            (0, _errorMessage.errorMessage)(err, 0, {
                source: EXPLORE_SIMPLE_PAGE_SOURCE,
                errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
            });
            return null;
        } finally{
            // Ensuring the state is always cleaned up.
            this.spinning = false;
            this.dataLoading = false;
            this._requestId = '';
        }
    }
    /**
   * Starts the frame request and returns the resulting data.
   */ async sendFrameRequest(body) {
        return await this.dataService.sendFrameRequest(body, {
            onProgress: (prog)=>{
                if (this.isConnected && this.percent !== null) {
                    this.percent.textContent = prog;
                }
            },
            onMessage: (msg)=>{
                (0, _errorMessage.errorMessage)(msg, 0, {
                    source: EXPLORE_SIMPLE_PAGE_SOURCE,
                    errorCode: _httpstatuscodes.StatusCodes.INTERNAL_SERVER_ERROR.toString()
                });
            },
            onStart: ()=>{
                if (this.isConnected && this.spinner) {
                    this.spinner.active = true;
                }
            },
            onSettled: ()=>{
                if (this.isConnected && this.spinner) {
                    this.spinner.active = false;
                }
            }
        });
    }
    get state() {
        return this._state;
    }
    set state(state) {
        var _this__state, _this__state1, _this__state2, _this__state3, _this__state4, _this__state5;
        const prevBegin = (_this__state = this._state) === null || _this__state === void 0 ? void 0 : _this__state.begin;
        const prevEnd = (_this__state1 = this._state) === null || _this__state1 === void 0 ? void 0 : _this__state1.end;
        const prevRequestType = (_this__state2 = this._state) === null || _this__state2 === void 0 ? void 0 : _this__state2.requestType;
        const prevQueries = [
            ...((_this__state3 = this._state) === null || _this__state3 === void 0 ? void 0 : _this__state3.queries) || []
        ];
        const prevFormulas = [
            ...((_this__state4 = this._state) === null || _this__state4 === void 0 ? void 0 : _this__state4.formulas) || []
        ];
        const prevKeys = (_this__state5 = this._state) === null || _this__state5 === void 0 ? void 0 : _this__state5.keys;
        state = this.rationalizeTimeRange(state);
        this._state = state;
        // Synchronize the xAxisSwitch with the state's domain
        const isDateDomain = this._state.domain === 'date';
        if (this.xAxisSwitch !== isDateDomain) {
            this.xAxisSwitch = isDateDomain;
        }
        if (this.range) {
            this.range.state = {
                begin: this._state.begin,
                end: this._state.end,
                num_commits: this._state.numCommits,
                request_type: this._state.requestType
            };
        }
        this.render();
        // If there is at least one query, the use the last one to repopulate the
        // query-sk dialog.
        const numQueries = this._state.queries.length;
        if (numQueries >= 1 && this.query) {
            this.query.paramset = (0, _query.toParamSet)(this._state.queries[numQueries - 1]);
            this.query.current_query = this._state.queries[numQueries - 1];
            this.summary.paramsets = [
                (0, _query.toParamSet)(this._state.queries[numQueries - 1])
            ];
        }
        this.applyQueryDefaultsIfMissing();
        if (numQueries === 0 && this._state.keys === '' && this._state.formulas.length === 0 && this.openQueryByDefault) {
            this.openQuery();
        }
        const encodedPrevQueries = prevQueries.map((q)=>encodeURIComponent(q));
        const encodedCurrentQueries = this._state.queries.map((q)=>encodeURIComponent(q));
        const queriesChanged = encodedPrevQueries.length !== encodedCurrentQueries.length || encodedPrevQueries.some((q, i)=>q !== encodedCurrentQueries[i]);
        const formulasChanged = prevFormulas.length !== this._state.formulas.length || prevFormulas.some((f, i)=>f !== this._state.formulas[i]);
        if (prevBegin !== this._state.begin || prevEnd !== this._state.end || prevRequestType !== this._state.requestType || queriesChanged || formulasChanged || prevKeys !== this._state.keys) {
            this.updateTestPickerUrl();
        }
        if (!state.doNotQueryData) {
            this.rangeChangeImpl();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('anomalies-source-changed', this._onAnomaliesSourceChanged);
    }
    get openQueryByDefault() {
        return this.hasAttribute('open-query-by-default');
    }
    set openQueryByDefault(val) {
        if (val) {
            this.setAttribute('open-query-by-default', '');
        } else {
            this.removeAttribute('open-query-by-default');
        }
    }
    get navOpen() {
        return this.hasAttribute('nav-open');
    }
    set navOpen(val) {
        if (val) {
            this.setAttribute('nav-open', '');
        } else {
            this.removeAttribute('nav-open');
        }
    }
    toggleDetails() {
        this.navOpen = !this.navOpen;
        this.render();
    }
    getTraceset() {
        var _this_dfRepo_value;
        var _this_dfRepo_value_dataframe_traceset;
        return (_this_dfRepo_value_dataframe_traceset = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe.traceset) !== null && _this_dfRepo_value_dataframe_traceset !== void 0 ? _this_dfRepo_value_dataframe_traceset : null;
    }
    getDataTraces() {
        var _this__dataframe_traceset;
        return (_this__dataframe_traceset = this._dataframe.traceset) !== null && _this__dataframe_traceset !== void 0 ? _this__dataframe_traceset : null;
    }
    getSelectedRange() {
        var _this_googleChartPlot_value;
        var _this_googleChartPlot_value_selectedRange;
        return (_this_googleChartPlot_value_selectedRange = (_this_googleChartPlot_value = this.googleChartPlot.value) === null || _this_googleChartPlot_value === void 0 ? void 0 : _this_googleChartPlot_value.selectedRange) !== null && _this_googleChartPlot_value_selectedRange !== void 0 ? _this_googleChartPlot_value_selectedRange : null;
    }
    getHeader() {
        if (this.dfRepo.value) {
            return this.dfRepo.value.header;
        }
        return null;
    }
    getCommitLinks() {
        return this.commitLinks;
    }
    getAnomalyMap() {
        var _this_dfRepo_value;
        const anomalies = (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.getAllAnomalies();
        return anomalies !== null && anomalies !== void 0 ? anomalies : {};
    }
    getParamSet() {
        var _this_query;
        var _this_query_paramset;
        return (_this_query_paramset = (_this_query = this.query) === null || _this_query === void 0 ? void 0 : _this_query.paramset) !== null && _this_query_paramset !== void 0 ? _this_query_paramset : {};
    }
    getDataFrame() {
        var _this_dfRepo_value;
        return ((_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.dataframe) && Object.keys(this.dfRepo.value.dataframe.traceset || {}).length > 0 ? this.dfRepo.value.dataframe : this._dataframe;
    }
    getSubDataFrame() {
        var _this__dataframe;
        return ((_this__dataframe = this._dataframe) === null || _this__dataframe === void 0 ? void 0 : _this__dataframe.header) && this._dataframe.header.length > 0 ? this._dataframe : this.getDataFrame();
    }
    set defaults(val) {
        this._defaults = val;
    }
    static getTraceMetadataFromCommitLinks(traces, commitLinks) {
        const traceMetadata = [];
        traces.forEach((trace)=>{
            const metadata = {
                traceid: trace,
                commitLinks: {}
            };
            commitLinks.forEach((link)=>{
                var _link;
                if (((_link = link) === null || _link === void 0 ? void 0 : _link.traceid) === trace) {
                    const linksForCommit = {};
                    if (link.displayTexts) {
                        for(const key in link.displayUrls){
                            linksForCommit[key] = {
                                Text: link.displayTexts[key],
                                Href: link.displayUrls[key]
                            };
                        }
                    }
                    metadata.commitLinks[link.cid] = linksForCommit;
                }
            });
            traceMetadata.push(metadata);
        });
        return traceMetadata;
    }
    getDefaultRange() {
        if (this._defaults && this._defaults.default_range) {
            return this._defaults.default_range;
        }
        return DEFAULT_RANGE_S;
    }
    clearHighlightedCircles() {
        this._state.highlight_anomalies = [];
        this._stateHasChanged();
        this.render();
    }
    clearAnomalyMap() {
        var _this_dfRepo_value;
        (_this_dfRepo_value = this.dfRepo.value) === null || _this_dfRepo_value === void 0 ? void 0 : _this_dfRepo_value.clearAnomalyMap();
        this.clearHighlightedCircles();
    }
    broadcastSelection() {
        const range = this.getSelectedRange();
        if (!range) return;
        const detail = {
            graphNumber: this.state.graph_index,
            value: range,
            domain: this.state.domain,
            start: this.getCommitIndex(range.begin, this.state.domain),
            end: this.getCommitIndex(range.end, this.state.domain, true)
        };
        this.dispatchEvent(new CustomEvent('selection-range-changed', {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }
    constructor(useTestPicker){
        super(ExploreSimpleSk.template);
        this.dataService = _dataservice.DataService.getInstance();
        this._dataframe = {
            traceset: (0, _json.TraceSet)({}),
            header: [],
            paramset: (0, _json.ReadOnlyParamSet)({}),
            skip: 0,
            traceMetadata: []
        };
        // The state that does into the URL.
        this._state = new State();
        // Set of customization params that have been explicitly specified
        // by the user.
        this._userSpecifiedCustomizationParams = new Set();
        // Controls the mode of the display. See FrameResponseDisplayMode.
        this.displayMode = 'display_query_only';
        // Are we waiting on data from the server.
        this._spinning = false;
        this._dialogOn = false;
        // The id of the current frame request. Will be the empty string if there
        // is no pending request.
        this._requestId = '';
        this.testPath = '';
        this.startCommit = '';
        this.endCommit = '';
        this.story = '';
        this.bugId = '';
        this.jobUrl = '';
        this.jobId = '';
        this.user = '';
        this._defaults = null;
        this._initialized = false;
        this.detailTab = null;
        this.formula = null;
        this.json = null;
        this.logEntry = null;
        this.paramset = null;
        this.percent = null;
        this.googleChartPlot = (0, _ref.createRef)();
        this.plotSummary = (0, _ref.createRef)();
        this.query = null;
        this.queryCount = null;
        this.range = null;
        this.spinner = null;
        this.summary = null;
        this.commitTime = null;
        this.pivotControl = null;
        this.pivotTable = null;
        this.pivotDisplayButton = null;
        this.queryDialog = null;
        this.helpDialog = null;
        // TODO(b/372694234): consolidate the pinpoint and triage toasts.
        this.pinpointJobToast = null;
        this.triageResultToast = null;
        this.closePinpointToastButton = null;
        this.closeTriageToastButton = null;
        this.collapseButton = null;
        this.traceFormatter = null;
        this.testPickerUrl = '#';
        this.commitLinks = [];
        this.chartTooltip = null;
        this.useTestPicker = false;
        this.is_chart_split = false;
        this.is_anomaly_table = false;
        this.enableRemoveButton = true;
        this.disablePointLinks = false;
        this.showHeader = true;
        this.showTabs = true;
        this.xAxisSwitch = false;
        this.zoomDirectionSwitch = false;
        this.summaryOptionsField = (0, _ref.createRef)();
        // Map with displayed summary bar option as key and trace key
        // as value. For example, {'...k1=v1,k2=v2' => ',ck1=>cv1,ck2=>cv2,k1=v1,k2=v2,'}
        this.summaryOptionTraceMap = new Map();
        // Map with displayed trace key as key and summary bar option
        // as value. For example, {',ck1=>cv1,ck2=>cv2,k1=v1,k2=v2,' => '...k1=v1,k2=v2'}
        this.traceIdSummaryOptionMap = new Map();
        // tooltipSelected tracks whether someone has turned on the tooltip
        // by selecting a data point. A new tooltip will not be created on
        // mouseover unless the current selected tooltip is closed.
        // true - the tooltip is selected
        // false - the tooltip is not selected but could be on via mouse hover
        this.tooltipSelected = false;
        this.graphTitle = null;
        this.tracesRendered = false;
        this.selectedAnomaly = null;
        this.hoverTimeout = -1;
        // material UI
        this.settingsDialog = null;
        this.dfRepo = (0, _ref.createRef)();
        this.isReportPage = false;
        this.uniqueId = `${ExploreSimpleSk.nextUniqueId++}`;
        this.exportCsvHandler = ()=>{
            const df = this.getSubDataFrame();
            if (!df || !df.traceset || Object.keys(df.traceset).length === 0) {
                (0, _errorMessage.errorMessage)('No traces available to export.');
                return;
            }
            const cleanDf = (0, _csv.removeSpecialTraces)(df);
            if (!cleanDf.traceset || Object.keys(cleanDf.traceset).length === 0) {
                (0, _errorMessage.errorMessage)('No traces available to export.');
                return;
            }
            const csvContent = (0, _csv.dataframeToCSV)(cleanDf);
            if (!csvContent) {
                (0, _errorMessage.errorMessage)('Failed to generate CSV from traces.');
                return;
            }
            const filename = `perf-traces-${Date.now()}.csv`;
            (0, _csv.downloadCSV)(filename, csvContent);
        };
        this.openAddFavoriteDialog = async ()=>{
            const d = (0, _dom.$$)('#fav-dialog', this);
            await d.open();
        };
        this.showZero = ()=>{
            this._state.showZero = !this._state.showZero;
            this.googleChartPlot.value.showZero = this._state.showZero;
            this.render();
        };
        this.loadDataFromExistingChart = async ()=>{
            const traceset = this.getTraceset();
            const paramSet = (0, _json.ParamSet)({});
            if (traceset) {
                Object.keys(traceset).forEach((key)=>{
                    if ((0, _paramtools.validKey)(key)) {
                        (0, _paramtools.addParamsToParamSet)(paramSet, (0, _paramtools.fromKey)(key));
                    }
                });
            }
            this.dispatchEvent(new CustomEvent('populate-query', {
                detail: paramSet,
                bubbles: true
            }));
        };
        this._onAnomaliesSourceChanged = (_e)=>{
            this.rangeChangeImpl();
        };
        // Call this anytime something in private state is changed. Will be replaced
        // with the real function once stateReflector has been setup.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this._stateHasChanged = ()=>{
            this.dispatchEvent(new CustomEvent('state_changed', {}));
        };
        this._renderedTraces = ()=>{
            this.dispatchEvent(new CustomEvent('rendered_traces', {}));
        };
        this.keyDown = (e)=>{
            // Ignore IME composition events.
            if (this._dialogOn || e.isComposing || e.keyCode === 229) {
                return;
            }
            // Allow user to type and not pan graph if the Existing Bug Dialog is showing.
            const existing_bug_dialog = (0, _dom.$$)('existing-bug-dialog-sk', this);
            if (existing_bug_dialog && existing_bug_dialog.isActive) {
                return;
            }
            // Allow user to type and not pan graph if the New Bug Dialog is showing.
            const new_bug_dialog = (0, _dom.$$)('new-bug-dialog-sk', this);
            if (new_bug_dialog && new_bug_dialog.opened) {
                return;
            }
            if (e.key === 'Escape') {
                this.closeTooltip();
                return;
            }
            (0, _keyboardshortcuts.handleKeyboardShortcut)(e, this);
        };
        this.traceFormatter = (0, _traceformatter.GetTraceFormatter)();
        this.useTestPicker = useTestPicker !== null && useTestPicker !== void 0 ? useTestPicker : false;
    }
};
(()=>{
    ExploreSimpleSk.nextUniqueId = 0;
})();
(()=>{
    // TODO(b/380215495): The current implementation of splitting the chart by
    // an attribute is buggy and not very intuitive. The split-chart-menu module
    // has therefore been removed until the bugs are fixed.
    ExploreSimpleSk.template = (ele)=>(0, _html.html)`
  <dataframe-repository-sk ${(0, _ref.ref)(ele.dfRepo)}>
  <div id=explore class=${ele.displayMode}>
    <div id=buttons style="display: none">
      <button
        id=open_query_dialog
        ?hidden=${ele.useTestPicker}
        @click=${ele.openQuery}>
        Query
      </button>
    </div>

    <div id=chartHeader
      ?hidden=${!ele.showHeader}
      class="hide_on_query_only hide_on_pivot_table hide_on_spinner">
      <graph-title-sk id=graphTitle style="flex-grow:  1;"></graph-title-sk>
      ${ele.isReportPage ? (0, _html.html)`
              <a href="${ele.testPickerUrl}">
                <md-icon-button title="Open in Multigraph">
                  <md-icon id="icon">north_west</md-icon>
                </md-icon-button>
              </a>
            ` : (0, _html.html)`
              <md-icon-button
                title="Load Test Picker with current Query"
                ?disabled=${ele.is_chart_split && !ele.useTestPicker}
                @click=${ele.loadDataFromExistingChart}>
                <md-icon id="icon">north_west</md-icon>
              </md-icon-button>
            `}
      <md-icon-button
        title="Show Zero on Axis"
        @click=${()=>{
            ele.showZero();
        }}>
        ${ele._state.showZero ? (0, _html.html)`<md-icon id="icon">radio_button_unchecked</md-icon>` : (0, _html.html)`<md-icon id="icon">hide_source</md-icon>`}
      </md-icon-button>
      <favorites-dialog-sk id="fav-dialog"></favorites-dialog-sk>
      <md-icon-button
        title="Add Chart to Favorites"
        ?disabled=${!ele._state.enable_favorites}
        @click=${()=>{
            ele.openAddFavoriteDialog();
        }}>
        <md-icon id="icon">favorite</md-icon>
      </md-icon-button>
      <md-icon-button
      id="showSettingsDialog"
        title="Show Settings Dialog"
        @click=${ele.showSettingsDialog}>
        <md-icon id="icon">settings</md-icon>
      </md-icon-button>
      <md-icon-button
        id="exportCsvBtn"
        title="Export traces as CSV"
        ?disabled=${!ele.hasTraces}
        @click=${ele.exportCsvHandler}>
        <md-icon id="icon">download</md-icon>
      </md-icon-button>
      <md-icon-button
        id="removeAll"
        ?disabled=${!ele.enableRemoveButton}
        @click=${()=>ele.closeExplore()}
        title='Remove all the traces.'>
        <close-icon-sk></close-icon-sk>
      </md-icon-button>
      <md-dialog
        aria-label='Settings dialog'
        id='settings-dialog'>
        <form id="form" slot="content" method="dialog">
        </form>
        <div slot="actions">
          <ul style="list-style-type:none; padding-left: 0;">
            <li>
              <label>
                <md-switch
                  form="form"
                  id="commit-switch"
                  ?selected="${ele.xAxisSwitch}"
                  @change=${(e)=>ele.switchXAxis(e.target)}></md-switch>
                X-Axis as Commit Date
              </label>
            </li>
            <li>
              <label>
                <md-switch
                  form="form"
                  id="zoom-direction-switch"
                  ?selected="${ele.zoomDirectionSwitch}"
                  @change=${(e)=>ele.switchZoom(e.target)}></md-switch>
                Switch Zoom Direction
              </label>
            </li>
            <li>
              <label>
                <md-switch
                  form="form"
                  id="even-x-axis-spacing-switch"
                  ?selected="${ele._state.evenXAxisSpacing}"
                  @change=${(e)=>ele.switchEvenXAxisSpacing(e.target)}></md-switch>
                Even X-Axis Spacing
              </label>
            </li>
          </ul>
        </div>
      </md-dialog>
    </div>

    <div id=spin-overlay @mouseleave=${ele.mouseLeave}>
    <div class="chart-container">
        ${(0, _html.html)`<plot-google-chart-sk
          .domain=${ele._state.domain}
          ${(0, _ref.ref)(ele.googleChartPlot)}
          .highlightAnomalies=${ele._state.highlight_anomalies}
          .useDiscreteAxis=${ele._state.evenXAxisSpacing}
          @plot-data-select=${ele.onChartSelect}
          @plot-data-mouseover=${ele.onChartOver}
          @selection-changing=${ele.OnSelectionRange}
          @selection-changed=${ele.OnSelectionRange}>
          <md-icon slot="untriage">help</md-icon>
          <md-icon slot="regression">report</md-icon>
          <md-icon slot="improvement">check_circle</md-icon>
          <md-icon slot="ignored">report_off</md-icon>
          <md-icon slot="issue">chat_bubble</md-icon>
          <md-text slot="xbar">|</md-text>
        </plot-google-chart-sk>`}
      <chart-tooltip-sk></chart-tooltip-sk>
      </div>
      ${(0, _when.when)(ele._state.plotSummary && ele.tracesRendered, ()=>ele.plotSummaryTemplate())}
      <div id=spin-container class="hide_on_query_only hide_on_pivot_table hide_on_pivot_plot hide_on_plot">
        <spinner-sk id=spinner active></spinner-sk>
        <pre id=percent></pre>
      </div>
  </div>

    <pivot-table-sk
      @change=${ele.pivotTableSortChange}
      disable_validation
      class="hide_on_plot hide_on_pivot_plot hide_on_query_only hide_on_spinner">
    </pivot-table-sk>

    <dialog id='query-dialog'>
      <h2>Query</h2>
      <div class=query-parts>
        <query-sk
          id=query
          @query-change=${ele.queryChangeHandler}
          @query-change-delayed=${ele.queryChangeDelayedHandler}
          > </query-sk>
          <div id=selections>
            <h3>Selections</h3>
            <button id="closeQueryIcon" @click=${ele.closeQueryDialog}>
              <close-icon-sk></close-icon-sk>
            </button>
            <paramset-sk id=summary removable_values @paramset-value-remove-click=${ele.paramsetRemoveClick}></paramset-sk>
            <div class=query-counts>
              Matches: <query-count-sk url='/_/count/' @paramset-changed=${ele.paramsetChanged}>
              </query-count-sk>
            </div>
          </div>
      </div>

      <details id=time-range-summary>
        <summary>Time Range</summary>
        <domain-picker-sk id=range>
        </domain-picker-sk>
      </details>

      <tabs-sk>
        <button>Plot</button>
        <button>Calculations</button>
        <button>Pivot</button>
        <button>JSON</button>
      </tabs-sk>
      <tabs-panel-sk>
        <div>
          <button @click=${()=>ele.add(true, 'query')} class=action>Plot</button>
          <button @click=${()=>ele.add(false, 'query')}>Add to Plot</button>
        </div>
        <div>
          <div class=formulas>
            <label>
              Enter a formula:
              <textarea id=formula-${ele.uniqueId} rows=3 cols=80></textarea>
            </label>
            <div>
              <button @click=${()=>ele.add(true, 'formula')} class=action>Plot</button>
              <button @click=${()=>ele.add(false, 'formula')}>Add to Plot</button>
              <button @click=${ele.onOpenHelp} title="Keyboard Shortcuts">Shortcuts</button>
              <a href=/help/ target=_blank title="Documentation">
                <help-icon-sk></help-icon-sk>
              </a>
            </div>
          </div>
        </div>
        <div>
          <pivot-query-sk
            @pivot-changed=${ele.pivotChanged}
            .pivotRequest=${ele._state.pivotRequest}
          >
          </pivot-query-sk>
          <div>
            <button
              id=pivot-display-button-${ele.uniqueId}
              @click=${()=>ele.add(true, 'pivot')}
              class=action
              .disabled=${(0, _pivotutil.validatePivotRequest)(ele._state.pivotRequest) !== ''}
            >Display</button>
          </div>
        </div>
        <div>
          <div class=formulas>
            <label>
              Enter a JSON:
              <textarea id=json-${ele.uniqueId} rows=10 cols=80></textarea>
            </label>
            <div>
              <button @click=${()=>ele.add(true, 'json')} class=action>Plot</button>
              <button @click=${()=>ele.add(false, 'json')}>Add to Plot</button>
              <a href=/help/ target=_blank>
                <help-icon-sk></help-icon-sk>
              </a>
            </div>
          </div>
        </div>
      </tabs-panel-sk>
      <div class=footer>
        <button @click=${ele.closeQueryDialog} id='close_query_dialog'>Close</button>
      </div>
    </dialog>

    <dialog id=help>
      <h2>Perf Help</h2>
      <table>
        <tr><td colspan=2><h3>Mouse Controls</h3></td></tr>
        <tr><td class=mono>Hover</td><td>Snap crosshair to closest point.</td></tr>
        <tr><td class=mono>Shift + Hover</td><td>Highlight closest trace.</td></tr>
        <tr><td class=mono>Click</td><td>Select closest point.</td></tr>
        <tr><td class=mono>Drag</td><td>Zoom into rectangular region.</td></tr>
        <tr><td class=mono>Wheel</td><td>Remove rectangular zoom.</td></tr>
        <tr><td colspan=2><h3>Keyboard Controls</h3></td></tr>
        <tr><td class=mono>'w'/'s'</td><td>Zoom in/out.<sup>1</sup></td></tr>
        <tr><td class=mono>'a'/'d'</td><td>Pan left/right.<sup>1</sup></td></tr>
        <tr><td class=mono>'?'</td><td>Show help.</td></tr>
        <tr><td class=mono>Esc</td><td>Stop showing help.</td></tr>
      </table>
      <div class=footnote>
        <sup>1</sup> And Dvorak equivalents.
      </div>
      <div class=help-footer>
        <button class=action @click=${ele.closeHelp}>Close</button>
      </div>
    </dialog>

    <keyboard-shortcuts-help-sk .handler=${ele}></keyboard-shortcuts-help-sk>

    ${ele.state.hide_paramset ? '' : (0, _html.html)`
            <div id="tabs" class="hide_on_query_only hide_on_spinner hide_on_pivot_table">
              <button
                class="collapser"
                id="collapseButton"
                @click=${(_e)=>ele.toggleDetails()}>
                ${ele.navOpen ? (0, _html.html)`<expand-less-icon-sk></expand-less-icon-sk>` : (0, _html.html)`<expand-more-icon-sk></expand-more-icon-sk>`}
              </button>
              <collapse-sk id="collapseDetails" .closed=${!ele.navOpen}>
                <tabs-sk id="detailTab">
                  <button>Params</button>
                </tabs-sk>
                <tabs-panel-sk>
                  <div>
                    <p><b>Time</b>: <span title="Commit Time" id="commit_time"></span></p>

                    <paramset-sk
                      id="paramset"
                      clickable_values
                      checkbox_values
                      @paramset-key-value-click=${(e)=>{
            ele.paramsetKeyValueClick(e);
        }}
                      @paramset-checkbox-click=${ele.paramsetCheckboxClick}
                      @paramset-key-checkbox-click=${ele.paramsetKeyCheckboxClick}>
                    </paramset-sk>
                  </div>
                </tabs-panel-sk>
              </collapse-sk>
            </div>
          `}
  </div>
  </dataframe-repository-sk>
  <toast-sk id="pinpoint-job-toast" duration=10000>
    Pinpoint bisection started: <a href=${ele.jobUrl} target=_blank>${ele.jobId}</a>.
    <button id="hide-pinpoint-toast" class="action">Close</button>
  </toast-sk>
  <toast-sk id="triage-result-toast" duration=5000>
    <span id="triage-result-text"></span><a id="triage-result-link"></a>
    <button id="hide-triage-toast" class="action">Close</button>
  </toast-sk>
  `;
})();
(0, _define.define)('explore-simple-sk', ExploreSimpleSk);
